import { List, ListItem, ListItemText } from "@material-ui/core";
import _ from "lodash";

import AmplitudeCustomConfig from "./configs/custom/Amplitude";
import BingAdOAuthCustomConfig from "./configs/custom/BingAdOAuth";
import BrazeCustomConfig from "./configs/custom/Braze";
import FBCustomAudiencesCustomConfig from "./configs/custom/FacebookCustomAudiences";
import FBPixelCustomConfig from "./configs/custom/FacebookPixel";
import AdjustS2SCustomConfig from "./configs/custom/AdjustS2S";
import GainsightCSCustomConfig from "./configs/custom/GainsightCS";
import GoogleAdsAudiencesConfig from "./configs/custom/GoogleAdsAudiences";
import GoogleAdsConversionAPIConfig from "./configs/custom/GoogleAdsConversionAPI";
import GoogleAdsInsightsConfig from "./configs/custom/GoogleAdsInsights";
import GoogleAdsRemarketingListsConfig from "./configs/custom/GoogleAdsRemarketingLists";
import GACustomConfig from "./configs/custom/GoogleAnalytics";
import GoogleCampaignManager360Config from "./configs/custom/GoogleCampaignManager360API";
import GooglePubSubCustomConfig from "./configs/custom/GooglePubSub";
import LinkedInAdsConversionsAPICustomConfig from "./configs/custom/LinkedInAdsConversionsAPI";
import LinkedInAudiencesConfig from "./configs/custom/LinkedInAudiences";
import LinkedInInsightsConfig from "./configs/custom/LinkedInInsights";
import MetaOAuthCustomConfig from "./configs/custom/MetaOAuth";
import MicrosoftAdsAudiencesConfig from "./configs/custom/MicrosoftAdsAudiences";
import MixpanelCustomConfig from "./configs/custom/Mixpanel";
import RedditAudiencesConfig from "./configs/custom/RedditAudiences";
import StackAdaptCustomConfig from "./configs/custom/StackAdapt";
import TikTokOAuthCustomConfig from "./configs/custom/TikTokOAuth";
import ViantAudiencesConfig from "./configs/custom/ViantAudiences";
import WebhooksCustomConfig from "./configs/custom/Webhooks";

import {
  AbSmartlyIcon,
  ActiveCampaignIcon,
  AdikteevIcon,
  AdjustIcon,
  AdLearnOpenPlatformIcon,
  AdMediaIcon,
  AdobeAnalyticsIcon,
  AdQuickIcon,
  AdrollIcon,
  AdtribaIcon,
  AirshipIcon,
  AlexaIcon,
  AlgoliaInsightsIcon,
  AmazonS3Icon,
  AmbassadorIcon,
  AmplitudeIcon,
  AnodotIcon,
  AppcuesIcon,
  AppLovinIcon,
  AppNexusIcon,
  AppsFlyerIcon,
  ApptimizeIcon,
  ApteligentIcon,
  AsayerIcon,
  AtatusIcon,
  AttributionIcon,
  AurycIcon,
  AutopilotHqIcon,
  AwsIcon,
  AwsKinesisIcon,
  AwsLambdaIcon,
  AzureIcon,
  BasisIcon,
  BatchIcon,
  BeamerIcon,
  BigQueryIcon,
  BimeAnalyticsIcon,
  BingIcon,
  BlendoIcon,
  BlueshiftIcon,
  BranchMetricsIcon,
  BrazeIcon,
  BrontoIcon,
  BucketIcon,
  BugHerdIcon,
  BugsnagIcon,
  ButtonIcon,
  BuzzBoardIcon,
  ByteGainIcon,
  CalixaIcon,
  CallinglyIcon,
  CalqIcon,
  CanduIcon,
  CannyIcon,
  CastleIcon,
  ChameleonIcon,
  ChartbeatIcon,
  ChartioIcon,
  ChurnZeroIcon,
  CJIcon,
  ClearbitIcon,
  ClearBrainIcon,
  CleverTapIcon,
  ClickyIcon,
  ClientSuccessIcon,
  CliffIcon,
  ComScoreIcon,
  ConvertFlowIcon,
  ConvertroIcon,
  CountlyIcon,
  CourierIcon,
  CrazyEggIcon,
  CrispIcon,
  CriteoIcon,
  CrowdPowerIcon,
  CruncherIcon,
  CustifyIcon,
  CustomerIOIcon,
  CustomerSuccessBoxIcon,
  CustomFitaiIcon,
  DatabricksIcon,
  DataLakesIcon,
  DelightedIcon,
  DigiohIcon,
  DreamdataIoIcon,
  DriftIcon,
  DripIcon,
  ElevioIcon,
  EmailAptitudeIcon,
  EmarsysIcon,
  EmmaIcon,
  EmptyIcon,
  EnjoyHqIcon,
  EpicaIcon,
  ErrorceptionIcon,
  EverflowIcon,
  ExperimentsbyGrowthhackersIcon,
  ExponeaIcon,
  ExtoleIcon,
  FacebookIcon,
  FactorsAiIcon,
  FirebaseIcon,
  FloodlightIcon,
  FlurryIcon,
  FoxMetricsIcon,
  FreshmarketerIcon,
  FreshsalesIcon,
  FriendbuyIcon,
  FullstoryIcon,
  FunnelEnvyIcon,
  FunnelFoxIcon,
  GainsightIcon,
  GainsightPxIcon,
  GameballIcon,
  GistIcon,
  GoedleIcon,
  GoogleAdsIcon,
  GoogleAnalyticsIcon,
  GoogleAnalyticsProxyIcon,
  GoogleCampaignManager360Icon,
  GoogleCloudFunctionIcon,
  GoogleCloudPubSubIcon,
  GoogleCloudStorageIcon,
  GoogleDisplay360Icon,
  GoogleTagManagerIcon,
  GosquaredIcon,
  HasOffersIcon,
  HawkeiIcon,
  HeadsUpAiIcon,
  HeapIcon,
  HellobarIcon,
  HelpScoutIcon,
  HitTailIcon,
  HotjarIcon,
  HubspotIcon,
  HullIcon,
  HydraIcon,
  IbmUniversalBehaviorExchangeIcon,
  ImpactRadiusIcon,
  ImprovelyIcon,
  IndicativeIcon,
  InkitIcon,
  InsiderIcon,
  InspectletIcon,
  InteranaIcon,
  IntercomIcon,
  IronIoIcon,
  IterableIcon,
  JackDbIcon,
  JournyioIcon,
  KahunaIcon,
  KameleoonIcon,
  KeenIoIcon,
  KevelIcon,
  KissmetricsIcon,
  KlaviyoIcon,
  KochavaIcon,
  KubitIcon,
  KustomerIcon,
  LanternIcon,
  LaunchDarklyEventsIcon,
  LeadSquaredIcon,
  LeanplumIcon,
  LearndotIcon,
  LibratoIcon,
  LinkedinIcon,
  LivechatIcon,
  LocalyticsIcon,
  LouIcon,
  LuckyOrangeIcon,
  LyticsIcon,
  MablIcon,
  MadKuduIcon,
  MailchimpIcon,
  MailjetIcon,
  MammothIcon,
  MarketoIcon,
  MarkettailorIcon,
  MatomoIcon,
  MediaMathIcon,
  MetaCxIcon,
  MicrosoftIcon,
  MillennialMediaIcon,
  MixpanelIcon,
  MntnIcon,
  ModeIcon,
  ModernPricingIcon,
  MoEngageIcon,
  MoesifApiAnalyticsIcon,
  MonetateIcon,
  MoosendIcon,
  MouseFlowIcon,
  MouseStatsIcon,
  MovableInkIcon,
  Msg91Icon,
  MutinyIcon,
  NanigansIcon,
  NateroIcon,
  NatIcon,
  NavilyticsIcon,
  NewRelicInsightsIcon,
  NielsenDcrIcon,
  NooraIcon,
  NudgespotIcon,
  OlarkIcon,
  OnesignalIcon,
  OptimizelyXIcon,
  OracleEloquaIcon,
  PanopolyIcon,
  PardotbySalesforceIcon,
  ParselyIcon,
  PendoIcon,
  PerfectAudienceIcon,
  PeriscopeDataIcon,
  PerkvilleIcon,
  PersistIqIcon,
  PersonyzeIcon,
  PingdomIcon,
  PinterestIcon,
  PixelMeIcon,
  PlanhatIcon,
  PodscribeIcon,
  PointillistIcon,
  PostgresqlIcon,
  PostHogIcon,
  ProductBirdIcon,
  ProfitWellIcon,
  PromoterIoIcon,
  ProofExperiencesIcon,
  ProsperStackIcon,
  QualarooIcon,
  QuantcastIcon,
  QuoraConversionPixelIcon,
  QuoraIcon,
  RadiumOneConnectIcon,
  RamenIcon,
  RecombeeAiIcon,
  RedditIcon,
  RedshiftIcon,
  RefersionIcon,
  RefinerIcon,
  RepeaterIcon,
  ReplayBirdIcon,
  ResponsysIcon,
  RetentlyIcon,
  RetinaIcon,
  RichpanelIcon,
  RockerboxIcon,
  RollbarIcon,
  Sailthruv2Icon,
  SalescampCrmIcon,
  SalesforceIcon,
  SalesmachineIcon,
  SatisMeterIcon,
  SavioIcon,
  ScopeAiIcon,
  ScreebIcon,
  SegIcon,
  SegMetricsIcon,
  SelligentMarketingCloudIcon,
  SendInBlueIcon,
  SentryIcon,
  SerenyticsIcon,
  ShareASaleIcon,
  SherlockIcon,
  SimpleReachIcon,
  SimplifiIcon,
  SingularIcon,
  SiriusXMIcon,
  SlackIcon,
  SlicingDiceIcon,
  SmartlookIcon,
  SnapboardIcon,
  NextdoorIcon,
  SnapchatIcon,
  SnapchatAudiencesIcon,
  SnapEngageIcon,
  SnowflakeIcon,
  SpinnakrIcon,
  SplitIcon,
  SpotifyIcon,
  StackAdaptIcon,
  StartdeliverIcon,
  StatsigIcon,
  StitchIcon,
  StonlyIcon,
  StoriesIcon,
  StormlyIcon,
  StrikedeckIcon,
  SurvicateIcon,
  SwrveIcon,
  TableauIcon,
  TalkableIcon,
  TalonOneIcon,
  TamberIcon,
  TaplyticsIcon,
  TapstreamIcon,
  TheTradeDeskIcon,
  TiktokIcon,
  TotangoIcon,
  TrackJsIcon,
  TractionboardIcon,
  TrafficGuardIcon,
  TrayIoIcon,
  TreasureDataIcon,
  TrustpilotIcon,
  TuneIcon,
  TvSquaredIcon,
  TwitterIcon,
  TwoMeeIcon,
  UnwaffleIcon,
  UpcallIcon,
  UserComIcon,
  UserIqIcon,
  UserLeapIcon,
  UserlikeIcon,
  UserlistIcon,
  UserpilotIcon,
  UserVoiceIcon,
  VarianceIcon,
  VeroIcon,
  VespucciIcon,
  ViantIcon,
  VibeIcon,
  VidoraIcon,
  VitallyIcon,
  VoucherifyIcon,
  VwoIcon,
  WalkMeIcon,
  WebEngageIcon,
  WebhookIcon,
  WhaleWatchIcon,
  WhalrIcon,
  WigzoIcon,
  WishpondIcon,
  WoopraIcon,
  XplentyIcon,
  XtremepushIcon,
  YandexMetricaIcon,
  YelpIcon,
  YouboraIcon,
  ZaiusIcon,
  ZapierIcon,
  ZendeskIcon,
  ZetaIcon,
} from "../components/icons/themes/logos";
import { CustomDestinationConfig } from "./configs/custom/types";

import {
  DestinationConnectionMode,
  LoadedDestinationInfo,
} from "../types/global";
import {
  ConfigFieldEntry,
  DestinationAutocompleteMappingEntry,
  DestinationKey,
  DestinationName,
  DestinationStandardMapping,
  FunctionDestinationData,
  FunctionKey,
  FunctionSlug,
  RequestableSaasDestinationData,
  SaaSDestinationData,
  SaaSDestinationKey,
  SaaSDestinationSlug,
  SaaSDestinationType,
  SquareLogoElement,
  StaticDestinationSlug,
  WarehouseDestinationData,
  WarehouseDestinationKey,
  WarehouseDestinationSlug,
  WarehouseDestinationType,
} from "./types";

import Meta from "@/components/icons/svg/logos/Meta";
import { FPConsentManagementCategory } from "../consent-management/consentManagement";
import { EventLibrary } from "../eventTypes";
import { FunctionConfigField } from "../functions/types";
import { getAdrollStandardMapping } from "./standard-mappings/adroll";
import { getBingStandardMapping } from "./standard-mappings/bing";
import { getFacebookStandardMapping } from "./standard-mappings/facebook";
import { getGoogleAdsStandardMapping } from "./standard-mappings/google-ads";
import { getPinterestStandardMapping } from "./standard-mappings/pinterest";
import { getTikTokStandardMapping } from "./standard-mappings/tiktok";
import { getTwitterStandardMapping } from "./standard-mappings/twitter";
import { DestinationCategory } from "./v2/DestinationCategory";
import StackAdaptAudiences from "@/destinations/configs/custom/StackAdaptAudiences";
import TheTradeDeskAudiences from "@/destinations/configs/custom/TheTradeDeskAudiences";

export const NewFunctionDestination = (
  props: FunctionDestinationData,
): SaaSDestination => {
  return new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: props.slug,
    name: props.name,
    key: "Function",
    type: "function",
    logoSquare: EmptyIcon,
    configName: props.config.configName || "Settings",
    configHelp:
      props.config.configHelp || "Configure your function destination",
    configFields: props.config.configFields
      ? props.config.configFields.map(functionConfigFieldToConfigFieldEntry)
      : [],
    supportsBackfill:
      typeof props.config.supportsBackfill === "undefined"
        ? true
        : props.config.supportsBackfill,
    supportsTrack:
      typeof props.config.supportsTrack === "undefined"
        ? true
        : props.config.supportsTrack,
    supportsCohorts:
      typeof props.config.supportsCohorts === "undefined"
        ? true
        : props.config.supportsCohorts,
    supportsServerSide: true,
    connectionMode: "server",
  });
};

const functionConfigFieldToConfigFieldEntry = (
  configField: FunctionConfigField,
): ConfigFieldEntry => {
  const configFieldEntry: ConfigFieldEntry = {
    name: configField.name || configField.key,
    key: configField.key,
    required: configField.required || false,
    description: configField.description || "",
    sensitive: configField.sensitive,
    type: configField.type !== "string" ? configField.type : undefined,
    defaultValue: configField.defaultValue,
  };

  if (configField.type === "radio") {
    configFieldEntry.options = configField.options.map((option) => ({
      value: option.value,
      label: option.label || option.value,
    }));
  } else if (configField.type === "select") {
    configFieldEntry.options = configField.options.map((option) => [
      option.label || option.value,
      option.value,
    ]);
  } else if (configField.type === "keyValueList") {
    configFieldEntry.defaultValue ||= [];
  }

  return configFieldEntry;
};

export class SaaSDestination {
  destinationCategories: DestinationCategory[];
  deprecated?: boolean;
  slug: SaaSDestinationSlug | FunctionSlug;
  name: string;
  key: SaaSDestinationKey | FunctionKey;
  type: SaaSDestinationType;
  logoSquare: SquareLogoElement;
  docsURL: string | null;
  docsShortName: string | null;
  settingsDescription: string | null;
  autocompleteMapping: DestinationAutocompleteMappingEntry[];
  configFields: ConfigFieldEntry[];
  configHelp: JSX.Element | string;
  configBodyHelp: JSX.Element | string;
  eventMappingSubheader: string;
  eventMappingBodyHelp: JSX.Element | string;
  eventMappingEventName: string;
  eventMappingConfigKey: string | null;
  connectionMode: DestinationConnectionMode;
  supportsCohorts: boolean;
  supportsTrack: boolean;
  supportsBackfill: boolean;
  supportsMultiConfig: boolean;
  supportsImpressionPixel: boolean;
  impressionPixelParams: Record<string, string> | null;
  impressionPixelParamsCM360: Record<string, string> | null;
  multiConfigLabel: string;
  configName: string;
  supportsServerSide: boolean;
  standardMappingConfig: DestinationStandardMapping | null;
  getStandardMapping: (() => Promise<DestinationStandardMapping>) | null;
  hasEventMapping: boolean;
  hasBAA: boolean;
  isMobileOnly: boolean;
  customConfig: CustomDestinationConfig | null;
  isFpEmployeeOnly: boolean;
  supportedSources: { [K in EventLibrary]?: boolean } | null;
  public readonly defaultConsentManagementCategory: FPConsentManagementCategory | null;
  oauthServiceAccountHelpURL: string | null;
  oauthUserAccountHelpURL: string | null;

  constructor(props: SaaSDestinationData) {
    const {
      destinationCategories,
      slug,
      name,
      type,
      key,
      logoSquare,
      docsURL,
      docsShortName,
      settingsDescription,
      autocompleteMapping,
      configFields,
      configHelp,
      configBodyHelp,
      eventMappingBodyHelp,
      eventMappingEventName,
      eventMappingConfigKey,
      eventMappingSubheader,
      connectionMode,
      supportsBackfill,
      supportsCohorts,
      supportsTrack,
      supportsServerSide,
      supportsMultiConfig,
      supportsImpressionPixel,
      impressionPixelParams,
      impressionPixelParamsCM360,
      multiConfigLabel,
      configName,
      standardMappingConfig,
      getStandardMapping,
      hasEventMapping,
      hasBAA,
      isMobileOnly,
      customConfig,
      isFpEmployeeOnly,
      supportedSources,
      defaultConsentManagementCategory,
      oauthServiceAccountHelpURL,
      oauthUserAccountHelpURL,
    } = props;

    this.destinationCategories = destinationCategories;
    this.slug = slug;
    this.name = name;
    this.type = type;
    this.key = key || name;

    this.logoSquare = logoSquare || null;
    this.docsURL = docsURL || null;
    this.docsShortName = docsShortName || null;

    this.supportsBackfill = supportsBackfill;
    this.supportsCohorts = !!supportsCohorts;
    this.supportsServerSide = supportsServerSide || supportsBackfill;
    this.supportsTrack = supportsTrack;
    this.supportsMultiConfig = supportsMultiConfig || false;
    this.supportsImpressionPixel = supportsImpressionPixel || false;
    this.impressionPixelParams = impressionPixelParams || null;
    this.impressionPixelParamsCM360 = impressionPixelParamsCM360 || null;
    this.multiConfigLabel = multiConfigLabel || "ID";
    this.connectionMode = connectionMode;
    this.configHelp = configHelp;
    this.configFields = configFields;
    this.customConfig = customConfig || null;
    this.configName =
      configName || _.map(this.configFields, ({ name }) => name).join(" & ");
    this.configBodyHelp = configBodyHelp || <></>;
    this.eventMappingEventName = eventMappingEventName || `${this.name} Event`;
    this.eventMappingSubheader =
      eventMappingSubheader || `Map your events to ${eventMappingEventName}s`;
    this.eventMappingBodyHelp = eventMappingBodyHelp || <></>;
    this.eventMappingConfigKey = eventMappingConfigKey || null;
    this.hasEventMapping = hasEventMapping || false;

    this.settingsDescription = settingsDescription || null;
    this.autocompleteMapping = autocompleteMapping || [];
    this.standardMappingConfig = standardMappingConfig || null;
    this.getStandardMapping = getStandardMapping || null;

    this.hasBAA = hasBAA || false;
    this.isMobileOnly = isMobileOnly || false;
    this.isFpEmployeeOnly = isFpEmployeeOnly || false;
    this.supportedSources = supportedSources || null;
    this.defaultConsentManagementCategory =
      defaultConsentManagementCategory || null;
    this.oauthServiceAccountHelpURL =
      oauthServiceAccountHelpURL || "bug: undefined service account help URL";
    this.oauthUserAccountHelpURL =
      oauthUserAccountHelpURL || "bug: undefined user account help URL";
  }

  categoryDisplay() {
    switch (this.type) {
      case "advertising":
        return "apps";
      case "app":
        return "apps";
      case "cohorting":
        return "cohorting";
      case "function":
        return "functions";
    }
  }

  configPageUrl() {
    return `/destinations/${this.categoryDisplay()}/${this.slug}`;
  }

  allowlistUrl() {
    return `/destinations/apps/${this.slug}/phiallowlist`;
  }
}

// A destination that we haven't enabled yet, but want to understand how many people want it
export class RequestableSaasDestination {
  destinationCategories: DestinationCategory[];
  slug: StaticDestinationSlug;
  name: string;
  logoSquare: SquareLogoElement;

  // The rest here are just set to default values to avoid breaking anything
  key: SaaSDestinationKey;
  type: SaaSDestinationType;
  settingsDescription: null;
  autocompleteMapping: DestinationAutocompleteMappingEntry[];
  configFields: ConfigFieldEntry[];
  configHelp: string;
  configBodyHelp: string;
  eventMappingSubheader: string;
  eventMappingBodyHelp: string;
  eventMappingEventName: string;
  eventMappingConfigKey: null;
  connectionMode: DestinationConnectionMode;
  supportsCohorts: boolean;
  supportsTrack: boolean;
  supportsBackfill: boolean;
  configName: string;
  supportsServerSide: boolean;
  standardMappingConfig: null;
  getStandardMapping: null;
  hasEventMapping: boolean;
  customConfig: null;

  constructor(props: RequestableSaasDestinationData) {
    const { destinationCategories, slug, name, logoSquare, key, type } = props;

    this.destinationCategories = destinationCategories;
    this.slug = slug;
    this.name = name;
    this.key = key;
    this.logoSquare = logoSquare || null;
    this.type = type;

    // The rest are just defaults and are unused
    this.supportsBackfill = false;
    this.supportsCohorts = false;
    this.supportsServerSide = false;
    this.supportsTrack = false;
    this.connectionMode = "client";
    this.configHelp = "";
    this.configFields = [];
    this.customConfig = null;
    this.configName = "";
    this.configBodyHelp = "";
    this.eventMappingEventName = "";
    this.eventMappingSubheader = "";
    this.eventMappingBodyHelp = "";
    this.eventMappingConfigKey = null;
    this.hasEventMapping = false;
    this.settingsDescription = null;
    this.autocompleteMapping = [];
    this.standardMappingConfig = null;
    this.getStandardMapping = null;
  }

  categoryDisplay() {
    switch (this.type) {
      case "advertising":
        return "advertising";
      case "app":
        return "apps";
      case "cohorting":
        return "cohorting";
      case "function":
        return "functions";
    }
  }
}

export class WarehouseDestination {
  destinationCategories: DestinationCategory[];
  slug: WarehouseDestinationSlug;
  name: string;
  key: WarehouseDestinationKey;
  supportsTrack: boolean;
  supportsCohorts: boolean;
  supportsBackfill: boolean;
  supportsServerSide: boolean;
  logoSquare: SquareLogoElement;
  type: WarehouseDestinationType;
  hasEventMapping = false;

  constructor(props: WarehouseDestinationData) {
    const {
      destinationCategories,
      key,
      name,
      supportsTrack,
      supportsCohorts,
      slug,
      logoSquare,
    } = props;

    this.destinationCategories = destinationCategories;
    this.slug = slug;
    this.name = name;
    this.key = key || name;
    this.supportsTrack = supportsTrack;
    this.supportsCohorts = !!supportsCohorts;
    this.supportsBackfill = true;
    this.supportsServerSide = true;
    this.type = "warehouse";
    this.logoSquare = logoSquare || null;
  }
}

export const warehouseDestinations: Record<
  WarehouseDestinationSlug,
  WarehouseDestination
> = {
  azure: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "azure",
    name: "Azure",
    key: "Azure",
    logoSquare: AzureIcon,
    supportsTrack: true,
  }),
  bigquery: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "bigquery",
    name: "BigQuery",
    key: "BigQuery",
    logoSquare: BigQueryIcon,
    supportsTrack: true,
  }),
  databricks: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "databricks",
    name: "Databricks",
    key: "Databricks",
    logoSquare: DatabricksIcon,
    supportsTrack: true,
  }),
  panoply: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "panoply",
    name: "Panoply",
    key: "Panoply",
    logoSquare: PanopolyIcon,
    supportsTrack: true,
  }),
  postgres: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "postgres",
    name: "Postgres",
    key: "Postgres",
    logoSquare: PostgresqlIcon,
    supportsTrack: true,
  }),
  redshift: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "redshift",
    name: "Redshift",
    key: "Redshift",
    logoSquare: RedshiftIcon,
    supportsTrack: true,
  }),
  s3: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "s3",
    name: "S3",
    key: "S3",
    logoSquare: AmazonS3Icon,
    supportsTrack: true,
  }),
  snowflake: new WarehouseDestination({
    destinationCategories: ["Data warehouse"],
    slug: "snowflake",
    name: "Snowflake",
    key: "Snowflake",
    logoSquare: SnowflakeIcon,
    supportsTrack: true,
  }),
};

export const saasDestinations: Record<
  SaaSDestinationSlug,
  SaaSDestination | RequestableSaasDestination
> = {
  autopilothq: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "autopilothq",
    name: "Autopilot",
    key: "AutopilotHQ",
    type: "app",
    logoSquare: AutopilotHqIcon,
    configHelp:
      "You can find your API Key by going to Settings -> App Connections -> Segment.",
    configFields: [
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  "active-campaign": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "active-campaign",
    name: "ActiveCampaign",
    key: "ActiveCampaign",
    type: "app",
    logoSquare: ActiveCampaignIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/active-campaign",
    configHelp: (
      <>
        You can find your API Key and API URL in the Developer page by clicking
        Settings &gt; Developer.
        <br />
        <br />
        You can find your Event Key under Event Tracking in the Tracking page by
        clicking Settings &gt; Tracking. From here, you can find your Account ID
        by clicking on Event Tracking API and finding "actid".
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        ActiveCampaign is an all-in-one email marketing, marketing automation,
        and CRM tool. With ActiveCampaign, you can build email newsletters,
        create email campaigns, and automate your CRM.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/activecampaign"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configName: "Credentials",
    configFields: [
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
      { name: "API URL", key: "apiUrl", required: true, sensitive: true },
      { name: "Account ID", key: "actId", required: true, sensitive: true },
      { name: "Event Key", key: "key", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "adjust-s2s": new SaaSDestination({
    destinationCategories: ["MMP"],
    slug: "adjust-s2s",
    name: "Adjust S2S",
    key: "Adjust S2S",
    type: "app",
    logoSquare: AdjustIcon,
    configHelp:
      "Provide your Adjust App Token and S2S Security Token. These can be found in the Adjust dashboard.",
    configFields: [
      { name: "App Token", key: "appToken", required: true },
      {
        name: "S2S Security Token",
        key: "s2sSecurityToken",
        required: true,
        sensitive: true,
      },
      {
        name: "Environment",
        key: "environment",
        type: "select",
        required: false,
        options: [
          ["Production", "production"],
          ["Sandbox", "sandbox"],
        ],
        defaultValue: "production",
      },
      {
        name: "Session Event Names",
        key: "sessionEventNames",
        required: false,
        defaultValue: "",
        placeholder: "Application Installed",
        mapControlValueToConfigValue: (val) =>
          typeof val === "string"
            ? val
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
            : val || [],
        mapConfigValueToControlValue: (val) =>
          Array.isArray(val) ? val.join(", ") : val || "",
        description:
          'Comma-separated list of Freshpaint event names that should be sent to Adjust as sessions (the /session endpoint). If left empty, defaults to "Application Installed". Sessions track app opens and installs in Adjust.',
      },
      {
        name: "Event Token Mapping",
        key: "eventTokenMapping",
        required: false,
        type: "keyValueList",
        defaultValue: [],
        keyValueListLabels: {
          keyLabel: "Freshpaint Event Name",
          valueLabel: "Adjust Event Token",
          objectLabel: "Mapping",
        },
        supportsCsvUpload: true,
        csvColumnMapping: { key: "name", value: "token" },
        description:
          "Map your Freshpaint event names to the corresponding Adjust event tokens. You can find event tokens in the Adjust dashboard under your app's events. Events without a mapping will not be sent to Adjust. You can also upload a CSV exported from the Adjust dashboard.",
      },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "appToken",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
    customConfig: AdjustS2SCustomConfig,
  }),
  "adobe-analytics": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "adobe-analytics",
    name: "AdobeAnalytics",
    key: "AdobeAnalytics",
    type: "app",
    logoSquare: AdobeAnalyticsIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/adobe-analytics",
    configHelp: (
      <>
        Find the Adobe Analytics report suite you''d like to send your results
        to. To find this ID, navigate to Adobe Analytics - Admin - Report Suites
        and select the report suite ID you want.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Adobe Analytics is a powerful analytics reporting and visualization tool
        that helps users slice their data and gain insights quickly.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/adobe-analytics"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configName: "Credentials",
    configFields: [
      {
        name: "Reporting Suite ID",
        key: "reportSuiteID",
        required: true,
        sensitive: false,
      },
      {
        name: "Send Page View Event",
        key: "sendPageView",
        type: "boolean",
        required: false,
        description: (
          <>
            Automatically send page_view events. Warning: disabling this event
            can cause the Adobe builtin dashboard to produce unexpected results.
          </>
        ),
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "analytics",
  }),
  adroll: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "adroll",
    name: "AdRoll",
    key: "AdRoll",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: AdrollIcon,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        AdRoll is a retargeting network that allows you to show ads across the
        web to visitors who previously landed on your site.
      </p>
    ),
    eventMappingEventName: "AdRoll Segment ID",
    eventMappingConfigKey: "_events",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Use your Freshpaint events to segment your users in AdRoll. AdRoll
        allows you to create a Segment Name and ID within AdRoll for conversion
        events. Use this mapping to trigger the AdRoll Segment ID whenever the
        Freshpaint Event occurs.
        <br />
        <br />
        Get started by creating a new segment in the AdRoll interface, copying
        the Segment ID, and pasting that following a + into the URL rule field
        (for example: “+f839c23v39”). Then map your Freshpaint event names to
        the corresponding AdRoll Segment ID.
      </p>
    ),
    configHelp: (
      <>
        You can find your Advertiser ID in your AdRoll dashboard by clicking the
        green or red dot in the lower-left corner. In the Javascript snippet,
        the Advertiser ID appears as adroll_avd_id = &apos;XXXXXXX&apos; on line
        2.
        <br />
        <br />
        You can find your Pixel ID in your AdRoll dashboard by clicking the
        green or red dot in the lower-left corner. In the Javascript snippet,
        the Pixel ID appears as adroll_pix_id = &apos;XXXXXXX&apos; on line 3.
      </>
    ),
    configName: "Pixel ID (Required)",
    configFields: [
      { name: "Advertiser ID", key: "advId", required: true },
      {
        name: "Pixel ID",
        key: "pixId",
        required: true,
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
    getStandardMapping: getAdrollStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  admedia: new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "admedia",
    name: "AdMedia",
    key: "AdMedia",
    type: "app",
    logoSquare: AdMediaIcon,
    configHelp:
      "Provide your AdMedia Advertiser ID. This can be found in your AdMedia account dashboard.",
    configFields: [{ name: "Advertiser ID", key: "ai", required: true }],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  amplitude: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "amplitude",
    name: "Amplitude",
    key: "Amplitude",
    type: "app",
    logoSquare: AmplitudeIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/amplitude",
    configHelp: "Find your API key on your project's dashboard.",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Amplitude is a leading Product Analytics tool. After sending Freshpaint
        data to Amplitude, teams can harness the power of product analytics to
        drive better, data-driven business outcomes.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/amplitude"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      { name: "API Key", key: "apiKey", required: true },
      {
        name: "Track Referrer",
        key: "trackReferrer",
        required: false,
        type: "boolean",
        description:
          "If enabled, Freshpaint will capture the user’s referrer, initial referrer, and referring domain," +
          " and send to Amplitude as user properties.",
      },
      {
        name: "Force HTTPS",
        key: "forceHttps",
        required: false,
        type: "boolean",
        description:
          "If enabled, events will always be uploaded to Amplitude's HTTPS endpoint. Otherwise the SDK" +
          "will use the current visitor's protocol.",
      },
      {
        name: "Use Log Revenue API V2",
        key: "useLogRevenueV2",
        required: false,
        type: "boolean",
        description: (
          <>
            If enabled, event properties are tracked with the revenue event. For
            example, you would be able to track a certain event and attach{" "}
            <code className="text-xs">price</code> and{" "}
            <code className="text-xs">quantity</code> properties to it. This
            feature will then log total revenue{" "}
            <code className="text-xs">(price*quantity)</code>.
          </>
        ),
      },
      {
        name: "Track UTM properties",
        key: "trackUtmProperties",
        required: false,
        type: "boolean",
        description:
          "If enabled, Freshpaint will capture UTM properties from the URL or cookie, and send to Amplitude as user properties.",
      },
      {
        name: "Track Google Click ID",
        key: "trackGclid",
        required: false,
        type: "boolean",
        description:
          "If enabled, Freshpaint will capture the Google Click ID, and send to Amplitude.",
      },
      {
        name: "Batch Events",
        key: "batchEvents",
        required: false,
        type: "boolean",
        description: (
          <>
            If enabled, amplitude will send events in batches of{" "}
            <span className="pt-1 font-mono">Batch Threshold</span> or every{" "}
            <span className="pt-1 font-mono">Batch Period</span> milliseconds.
          </>
        ),
      },
      {
        name: "Batch Threshold",
        key: "eventUploadThreshold",
        required: false,
        type: "number",
        description: "The number of events.",
        enabledIfCheckbox: "batchEvents",
      },
      {
        name: "Batch Period",
        key: "eventUploadPeriodMillis",
        required: false,
        type: "number",
        description: "The period between batches in milliseconds.",
        enabledIfCheckbox: "batchEvents",
      },
      {
        key: "saveParamsReferrerOncePerSession",
        name: "Save Referrer, URL Params, GCLID Once Per Session",
        required: false,
        sensitive: false,
        defaultValue: false,
        type: "boolean",
        description: (
          <>
            If enabled then Google Click ID, Referrer, and UTM params will be
            tracked only once per session. New values that come in during the
            middle of the user&apos;s session will be ignored. Disable to always
            capture new values.
          </>
        ),
      },
      {
        key: "preferAnonymousIdForDeviceId",
        name: "Use Freshpaint ID for Device ID",
        required: false,
        sensitive: false,
        defaultValue: false,
        type: "boolean",
        description: (
          <>
            Changing this setting will break historical data, so only enable
            this if you&apos;re setting up a new Amplitude project.
            <br />
            Enable this setting to make the Amplitude javascript web SDK use the
            Freshpaint device ID. This improves data consistency - you&apos;ll
            see the same device id for data streamed from your customers&apos;
            web browsers as for data backfilled from freshpaint&apos;s servers.
          </>
        ),
      },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "client",
    customConfig: AmplitudeCustomConfig,
    defaultConsentManagementCategory: "analytics",
  }),
  appboy: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "appboy",
    name: "Braze (formerly Appboy)",
    logoSquare: BrazeIcon,
    supportsTrack: true,
    supportsBackfill: false,
    connectionMode: "client",
    type: "app",
    key: "Appboy",
    customConfig: BrazeCustomConfig,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/appboy",
    configName: "Settings",
    configHelp: "Setup your Braze integration:",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Braze is a customer engagement platform. You can send events to Braze to
        complement the engagement that they already track, allowing you to see a
        fuller picture of your users&apos; behavior.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/appboy"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    supportsServerSide: true,
    configFields: [
      {
        name: "API Key",
        key: "apiKey",
        required: true,
        description:
          "This is found on your Braze dashboard under App Settings > Developer Console. Limit the permissions of this API key to the 'users.track' endpoint only.",
      },
      {
        name: "App Identifier",
        key: "appIdentifier",
        required: true,
        description: (
          <>
            When using the server-side connection mode, this identifier can be
            used to associate your events with a specific app that you&apos;ve
            configured on your Braze account. When using client-side connection
            mode, will be used to send your events. For more information, please{" "}
            <a href="https://www.braze.com/docs/api/api_key/">click here</a> to
            read Braze&apos;s REST API key overview.
          </>
        ),
      },
      {
        name: "SDK Version",
        key: "version",
        required: false,
        type: "select",
        options: [
          ["1", "1"],
          ["2", "2"],
          ["2.7", "2.7"],
          ["3.1", "3.1"],
        ],
        description: "The version of the Braze web SDK you use.",
      },
      {
        name: "REST Endpoint",
        key: "customEndpoint",
        required: true,
        description: (
          <>
            Every Braze account has its own{" "}
            <a href="https://www.braze.com/docs/api/basics/#endpoints">
              REST endpoint
            </a>
            ; you must enter yours here.
          </>
        ),
      },
      {
        name: "Safari Website Push ID",
        key: "safariWebsitePushId",
        required: false,
        description:
          "If you want to send push notifications via Safari, provide your safari push ID here.",
      },
      {
        name: "Do Not Load Font Awesome",
        key: "doNotLoadFontAwesome",
        type: "boolean",
        required: false,
        description:
          "By default, Braze will automatically load FontAwesome from the FontAwesome cdn for in-app icons. To disable this behavior (e.g. because your site uses a customized version of FontAwesome), set this option to true. Note that if you do this, you are responsible for ensuring that FontAwesome is loaded on your site - otherwise in-app messages may not render correctly.",
      },
      {
        name: "Allow Crawler Activity",
        key: "allowCrawlerActivity",
        required: false,
        type: "boolean",
        description:
          "By default, Braze ignores activity from spiders & crawlers (such as Google).",
      },
      {
        name: "Enable Logging",
        key: "enableLogging",
        required: false,
        type: "boolean",
        description:
          "This will put Braze into debug mode and log to the javascript console.",
      },
      {
        name: "Automatically Display Messages",
        key: "automaticallyDisplayMessages",
        type: "boolean",
        required: false,
        defaultValue: true,
        description:
          "Automatically delivers In-App Messages that a user is eligible for.",
      },
      {
        name: "Open in-app messages in new tabs",
        key: "openInAppMessagesInNewTab",
        type: "boolean",
        required: false,
        description:
          "By default, links from in-app message clicks load in the current tab or a new tab as specified in the " +
          "dashboard on a message-by-message basis. Enable this option to force all links from in-app message clicks " +
          "open in a new tab or window.",
      },
      {
        name: "Open newsfeed cards in new tabs",
        key: "openNewsFeedCardsInNewTab",
        type: "boolean",
        required: false,
        description:
          "By default, links from Card objects load in the current tab or window. Enable this option to make links from" +
          " cards open in a new tab or window.",
      },
      {
        name: "Require explicit in-app message dismissal",
        key: "requireExplicitInAppMessageDismissal",
        type: "boolean",
        required: false,
        description:
          "By default, when an in-app message is showing, pressing the escape button or a click on the greyed-out " +
          "background of the page will dismiss the message. Enable this option to prevent this behavior and require " +
          "an explicit button click to dismiss messages.",
      },
      {
        name: "Enable HTML in in-app messages",
        key: "enableHtmlInAppMessages",
        type: "boolean",
        required: false,
        description:
          "By default, the Braze Web SDK does not enable HTML in-app messages, as they allow Braze dashboard " +
          "users to run Javascript on your site. To indicate that you trust the Braze dashboard users to write " +
          "non-malicious HTML in-app messages, enable this option.",
      },
    ],
  }),
  appcues: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "appcues",
    name: "Appcues",
    key: "Appcues",
    type: "app",
    logoSquare: AppcuesIcon,
    configHelp: "Find your Account ID in the settings page.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/appcues",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Appcues is an onboarding software solution that also makes it easy to
        measure product adoption.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/appcues"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [{ name: "Account ID", key: "appcuesId", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  appsflyer: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "appsflyer",
    name: "AppsFlyer",
    key: "AppsFlyer",
    type: "app",
    logoSquare: AppsFlyerIcon,
    configHelp: "",
    configBodyHelp: (
      <>
        <p className="text-textSubtle text-xs">
          AppsFlyer is a mobile client-side destination, so you need to install
          and initialize the integration in your Android and iOS
          applications&apos; code.
        </p>

        <List>
          <ListItem
            component="a"
            target="_blank"
            href="https://github.com/freshpaint-io/freshpaint-android-integration-appsflyer#appsflyer---freshpaint-integration"
          >
            <ListItemText>Android Instructions</ListItemText>
          </ListItem>
          <ListItem
            component="a"
            target="_blank"
            href="https://github.com/freshpaint-io/freshpaint-ios-integration-appsflyer#appsflyer-integration-for-freshpaint."
          >
            <ListItemText>iOS Instructions</ListItemText>
          </ListItem>
        </List>
      </>
    ),
    configFields: [], // :TODO: (jmtaber129): Add these once we add a server-side impl or support fetch client-side dest configs.
    supportsTrack: true,
    supportsBackfill: false,
    isMobileOnly: true,
    connectionMode: "client",
  }),
  basis: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "basis",
    name: "Basis",
    key: "Basis",
    type: "app",
    logoSquare: BasisIcon,
    configHelp: "Provide your encrypted universal pixel ID from Basis.",
    configFields: [{ name: "Pixel ID", key: "pixelId", required: true }],
    supportsServerSide: true,
    supportsBackfill: false,
    supportsTrack: true,
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $cntr_auctionId: "{auctionId}",
    },
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    defaultConsentManagementCategory: "marketing",
  }),
  "bing-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "bing-ads",
    name: "Bing Ads",
    key: "Bing Ads",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: BingIcon,
    eventMappingConfigKey: "_events",
    eventMappingEventName: "Bing Standard Event",
    eventMappingBodyHelp: (
      <p className="text-sm">
        In order for Freshpaint to map your events to a Bing Conversion Goal,
        you will first need to create the goal in your Bing Ads account.
        <br />
        <br />
        You will complete the event mapping in your Bing Ads account as part of
        creating your Conversion Goal. Make sure to add the Freshpaint event
        name as the label field and to associate the goal to the correct Tag ID
        (<b>Bing Universal Event Tracking Tag ID</b>) that is set up in
        Freshpaint.
      </p>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        When you integrate Bing Ads in Freshpaint, events from Freshpaint will
        be sent to Bing Ads, so you can set up a goal in Bing Ads that is
        triggered by those events you’ve already got installed, rather than
        needing to write any new code into your site.
      </p>
    ),
    configHelp:
      "Add your Bing Universal Event Tracking Tag ID to create campaigns and advertise your product in Bing search.",
    configFields: [
      {
        name: "Tag ID",
        key: "tagId",
        required: true,
      },
      {
        name: "Automatically Send Page View Events",
        key: "builtInPageViewEnabled",
        type: "boolean",
        required: true,
        defaultValue: true,
        description: (
          <>
            Automatically send built-in page_view events. Warning: If you
            disable this and want to send page_view events, you must set up a
            custom page_view event. See{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/bing-ads/bing-ads-multi-config-reference"
              rel="noopener noreferrer"
              target="_blank"
            >
              Freshpaint Bing Ads Multi-Config Documentation
            </a>{" "}
            for more details.
          </>
        ),
      },
    ],
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/bing-ads",
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
    getStandardMapping: getBingStandardMapping,
    supportedSources: { web: true, "call-rail": true },
    defaultConsentManagementCategory: "marketing",
    supportsMultiConfig: true,
    multiConfigLabel: "Tag ID",
  }),
  "bing-insights": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "bing-insights",
    name: "Bing Insights",
    key: "Bing Insights",
    type: "advertising",
    logoSquare: BingIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Account ID",
    supportsTrack: false,
    supportsCohorts: false,
    configHelp:
      "Add your Developer Token, Account ID, and Customer ID to connect your Bing Ads account to Freshpaint.",
    configBodyHelp: (
      <p className="text-sm">
        The Bing Insights destination allows Freshpaint to access your Bing Ads
        campaign information and use it to enable the Insights Product.
        <br />
        <br />
        This destination is not able to process events and cannot be used to
        send events to Bing Ads. If you&apos;re looking to send events to Bing
        Ads, please use the Bing Ads destination instead.
      </p>
    ),
    configFields: [
      {
        name: "Developer Token",
        key: "developerToken",
        required: true,
        sensitive: true,
      },
      { name: "Account ID", key: "accountID", required: true },
      { name: "Manager Account ID", key: "managerAccountID", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: BingAdOAuthCustomConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  bugsnag: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "bugsnag",
    name: "Bugsnag",
    key: "Bugsnag",
    type: "app",
    logoSquare: BugsnagIcon,
    configHelp: "Find your API Key in the settings page.",
    configFields: [{ name: "API Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  castle: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "castle",
    name: "Castle",
    key: "Castle",
    type: "app",
    logoSquare: CastleIcon,
    configHelp: "Find your Publishable API Key in the settings page.",
    configFields: [
      { name: "Publishable API Key", key: "publishableKey", required: true },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  chameleon: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "chameleon",
    name: "Chameleon",
    key: "Chameleon",
    type: "app",
    logoSquare: ChameleonIcon,
    configHelp:
      'Go to "Install via Freshpaint" and paste the provided token below. If Chameleon also displays a Fast URL, then paste that below as well.',
    configFields: [
      { name: "Token", key: "apiKey", required: true },
      { name: "Fast URL", key: "fastUrl", required: false },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  cj: new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "cj",
    name: "CJ",
    key: "CJ",
    type: "app",
    logoSquare: CJIcon,
    configHelp:
      "Provide your CJ Personal Access Token, Enterprise ID, and Action Tracker ID. These can be found in the CJ Affiliate platform.",
    configFields: [
      {
        name: "CJ Personal Access Token",
        key: "personalAccessToken",
        required: true,
        sensitive: true,
      },
      { name: "Enterprise ID", key: "enterpriseId", required: true },
      { name: "Action Tracker ID", key: "actionTrackerId", required: true },
    ],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  "clearbit-enrichment": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "clearbit-enrichment",
    name: "Clearbit Enrichment",
    key: "Clearbit Enrichment",
    type: "app",
    logoSquare: ClearbitIcon,
    configHelp: (
      <>
        Find your Secret API Key (starts with 'sk_') on the{" "}
        <a href="https://dashboard.clearbit.com/api">API page</a>
      </>
    ),
    configFields: [{ name: "API Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: false,
    connectionMode: "server",
  }),
  clevertap: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "clevertap",
    name: "CleverTap",
    logoSquare: CleverTapIcon,
    type: "app",
    key: "CleverTap",
    configHelp: (
      <>
        Your CleverTap Account ID and region are found in your dashboard&#39;s
        URL, for example
        https://&lt;REGION&gt;.dashboard.clevertap.com/&lt;ACCOUNT_ID&gt;/account-setup/account-details/overview
      </>
    ),
    configFields: [
      { name: "Account ID", key: "clevertap_account_id", required: true },
      {
        description: "Your dedicated Clevertap region.",
        name: "Region",
        key: "region",
        type: "select",
        required: false,
        defaultValue: "EU1",
        options: [
          ["EU1", "EU1"],
          ["IN1", "IN1"],
          ["SG1", "SG1"],
          ["US1", "US1"],
        ],
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  crisp: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "crisp",
    name: "Crisp",
    key: "Crisp",
    type: "app",
    logoSquare: CrispIcon,
    configName: "Settings",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/crisp",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://crisp.chat/en/integrations/urn:perfalytics.inc:freshpaint:0/"
        >
          Install the Freshpaint plugin
        </a>{" "}
        from Crisp&apos;s marketplace in order for Freshpaint&apos;s servers to
        be able to access your Crisp site.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/crisp"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: (
      <>
        Find your Website ID at Settings &gt; Website Settings &gt; Settings
        &gt; Setup Instructions.
        <br />
        <br />
        Additionally,{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://crisp.chat/en/integrations/urn:perfalytics.inc:freshpaint:0/"
        >
          install the Freshpaint plugin
        </a>{" "}
        from Crisp's marketplace in order for Freshpaint's servers to be able to
        access your Crisp site.
      </>
    ),
    configFields: [{ name: "Website ID", key: "websiteId", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
  }),
  "crazy-egg": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "crazy-egg",
    name: "Crazy Egg",
    key: "Crazy Egg",
    type: "app",
    logoSquare: CrazyEggIcon,
    configHelp: "Find your Account Number under Account > Your Profile.",
    configFields: [
      { name: "Account Number", key: "accountNumber", required: true },
    ],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "customer-io": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "customer-io",
    name: "Customer.io",
    key: "Customer.io",
    type: "app",
    logoSquare: CustomerIOIcon,
    configHelp:
      "Your credentials can be found under Integrations > Customer.io API.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/customer-io",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Customer.io is an all-in-one messaging platform. You can schedule
        emails, SMS messages, and more with Customer.io.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/customer-io"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configName: "Credentials",
    configFields: [
      { name: "Site ID", key: "siteId", required: true },
      {
        name: "Secret API Key",
        key: "secretAPIKey",
        required: true,
        sensitive: true,
      },
      {
        name: "Datacenter region",
        key: "datacenter",
        required: false,
        sensitive: false,
        type: "select",
        options: [
          ["us", "United States"],
          ["eu", "European Union"],
        ],
        defaultValue: "us",
        description: (
          <>
            Freshpaint will send your events to your preferred
            Customer.io&apos;s{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://customer.io/docs/data-centers/"
            >
              datacenter
            </a>{" "}
            region. In Customer.io, be sure to assert Data Residency under{" "}
            <b className="text-xs">Settings</b> &gt;{" "}
            <b className="text-xs">Account Settings</b> &gt;{" "}
            <b className="text-xs">Data and Privacy.</b> Make sure you&apos;ve
            followed{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="hhttps://customer.io/docs/data-centers/#account-migration"
            >
              Customer.io&apos;s help instructions
            </a>{" "}
            to migrate your account to their EU datacenter if you so desire.
          </>
        ),
      },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "client",
  }),
  drift: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "drift",
    name: "Drift",
    key: "Drift",
    type: "app",
    logoSquare: DriftIcon,
    configHelp: "Your token is in quotes at the end of your JS script.",
    configFields: [{ name: "Token", key: "embedId", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  drip: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "drip",
    name: "Drip",
    key: "Drip",
    type: "app",
    logoSquare: DripIcon,
    configHelp: "Your token is in your JS script after '_dcs.account ='.",
    configFields: [{ name: "Token", key: "account", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  elevio: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "elevio",
    name: "Elevio",
    key: "Elevio",
    type: "app",
    logoSquare: ElevioIcon,
    configHelp: "Find your Account ID on the install page.",
    configFields: [{ name: "Account ID", key: "accountId", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  errorception: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "errorception",
    name: "Errorception",
    key: "Errorception",
    type: "app",
    logoSquare: ErrorceptionIcon,
    configHelp: "Your token is in the URL after '/projects/'.",
    configFields: [{ name: "Token", key: "projectId", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "facebook-conversions-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "facebook-conversions-api",
    name: "Facebook Conversions API",
    key: "Facebook Conversions API",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: FacebookIcon,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-conversions-api",
    configHelp: (
      <>
        Find your Pixel ID in the Events Manager.
        <br />
        <br />
        Generate an Access Token in Events Manager under Settings -&gt;
        Conversions API -&gt; Set up manually -&gt; Generate Access Token
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-conversions-api"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Similar to the Facebook Pixel integration, Facebook Conversions API
        optimizes the performance of your Facebook Ads. Freshpaint uses the
        Facebook Conversions API to enable you to automatically send event data
        back to Facebook for more efficient ad spend.
        <br />
        <br />
        Facebook Conversions API is used to send data to your Facebook Pixel
        from your servers or other non-web sources.
        <br />
        <br />
        If you are a HIPAA customer, you may also choose to route data from your
        website through Facebook Conversions API, in order to avoid exposing
        private health information to Facebook.
        <br />
        <br />
        To send data from your website directly to Facebook without routing
        through Freshpaint&apos;s servers, use the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="/destinations/apps/facebook-pixel"
        >
          Facebook Pixel integration
        </a>
        .
        <br />
        <br />
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-conversions-api"
        >
          Freshpaint Documentation &gt;
        </a>
      </p>
    ),
    configFields: [
      { name: "Pixel ID", key: "pixelId", required: true },
      {
        name: "Access Token",
        key: "accessToken",
        sensitive: true,
        required: true,
      },
      {
        name: "Pass Multiple External IDs",
        key: "shouldPassMultipleExternalIds",
        required: false,
        type: "boolean",
        description: (
          <>
            If true, we will pass both Freshpaint UserID and DeviceID to
            Facebook as the ExternalID.
          </>
        ),
      },
    ],
    eventMappingEventName: "Facebook Standard Event",
    eventMappingConfigKey: "_standardEvents",
    eventMappingSubheader: "Map your events to Standard FB Events",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized. Facebook recognizes{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.facebook.com/docs/facebook-pixel/reference#standard-events"
        >
          certain standard events
        </a>{" "}
        that can be used across custom audiences, custom conversions, conversion
        tracking, and conversion optimization within Facebook. When you map an
        event to a standard Facebook event, we will automatically send the event
        by that name to Facebook. Unmapped events can still be sent to Facebook
        as custom events.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    autocompleteMapping: [
      { name: "AddPaymentInfo" },
      { name: "AddToCart" },
      { name: "AddToWishlist" },
      { name: "CompleteRegistration" },
      { name: "Contact" },
      { name: "CustomizeProduct" },
      { name: "Donate" },
      { name: "FindLocation" },
      { name: "InitiateCheckout" },
      { name: "Lead" },
      { name: "PageView" },
      { name: "Purchase" },
      { name: "Schedule" },
      { name: "Search" },
      { name: "StartTrial" },
      { name: "SubmitApplication" },
      { name: "Subscribe" },
      { name: "ViewContent" },
    ],
    getStandardMapping: getFacebookStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  "facebook-custom-audiences": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "facebook-custom-audiences",
    name: "Facebook Custom Audiences",
    key: "Facebook Custom Audiences",
    type: "cohorting",
    logoSquare: FacebookIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: false,
    supportsCohorts: true,
    configHelp: (
      <>
        You can get your Ad Account ID by going to the{" "}
        <a href="https://business.facebook.com/settings">
          Facebook Business Settings
        </a>
        , clicking Ad Accounts, and copying your Ad Account ID at the top of the
        page.
      </>
    ),
    configFields: [
      { name: "Ad Account ID", key: "adAccountId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: FBCustomAudiencesCustomConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "facebook-pixel": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "facebook-pixel",
    name: "Facebook Pixel",
    key: "Facebook Pixel",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: FacebookIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-pixel",
    configHelp: (
      <>
        Find your Pixel ID in the Events Manager.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-pixel"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details
      </>
    ),
    configFields: [
      { name: "Pixel ID", key: "pixelId", required: true },
      {
        name: "Advanced Matching",
        key: "initWithExistingTraits",
        required: false,
        type: "boolean",
        description: (
          <>
            If true, we will initialize Facebook Pixel with any user traits that
            have been cached in the Freshpaint cookies from your previous
            .identify() calls.
          </>
        ),
      },
      {
        name: "Use UserId or Anonymous Id as External Id",
        key: "userIdAsExternalId",
        required: false,
        type: "boolean",
        description: (
          <>
            Enable this setting if you want to send userId (or anonymousId if
            not present) as external Id to Facebook. Must have "Advanced
            Matching" enabled.
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The Facebook Pixel integration optimizes the performance of your
        Facebook Ads. Freshpaint adds Facebook Pixel to your site and enables
        you to automatically send event data back to Facebook for more efficient
        ad spend.{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.facebook.com/docs/facebook-pixel"
        >
          Facebook Pixel Documentation {">"}
        </a>
        <br />
        <br />
        To send events to Facebook Pixel from your server or other non-web
        sources, use the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="/destinations/apps/facebook-conversions-api"
        >
          Facebook Conversions API destination.
        </a>
        <br />
        <br />
        If you are a HIPAA customer, to prevent exposing private health
        information to Facebook, use the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="/destinations/apps/facebook-conversions-api"
        >
          Facebook Conversions API destination.
        </a>
        <br />
        <br />
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/facebook-pixel"
        >
          Freshpaint Documentation &gt;
        </a>
      </p>
    ),
    customConfig: FBPixelCustomConfig,
    eventMappingEventName: "Facebook Standard Event",
    eventMappingConfigKey: "_standardEvents",
    eventMappingSubheader: "Map your events to Standard FB Events",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized. Facebook recognizes{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.facebook.com/docs/facebook-pixel/reference#standard-events"
        >
          certain standard events
        </a>{" "}
        that can be used across custom audiences, custom conversions, conversion
        tracking, and conversion optimization within Facebook. When you map an
        event to a standard Facebook event, we will automatically send the event
        by that name to Facebook. Unmapped events can still be sent to Facebook
        as custom events.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
    autocompleteMapping: [
      { name: "AddPaymentInfo" },
      { name: "AddToCart" },
      { name: "AddToWishlist" },
      { name: "CompleteRegistration" },
      { name: "Contact" },
      { name: "CustomizeProduct" },
      { name: "Donate" },
      { name: "FindLocation" },
      { name: "InitiateCheckout" },
      { name: "Lead" },
      { name: "PageView" },
      { name: "Purchase" },
      { name: "Schedule" },
      { name: "Search" },
      { name: "StartTrial" },
      { name: "SubmitApplication" },
      { name: "Subscribe" },
      { name: "ViewContent" },
    ],
    getStandardMapping: getFacebookStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  "facebook-pixel-proxy": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "facebook-pixel-proxy",
    name: "Facebook Pixel (Server-Side)",
    key: "Facebook Pixel Proxy",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: FacebookIcon,
    docsURL:
      "https://documentation.freshpaint.io/destinations/advertising-destinations/facebook-pixel-proxy",
    configHelp: (
      <>
        Find your Pixel ID in the Events Manager.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://documentation.freshpaint.io/destinations/advertising-destinations/facebook-pixel-proxy"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Similar to the Facebook Conversions API, the Facebook Pixel API
        optimizes the performance of your Facebook Ads. Freshpaint uses the
        Facebook Pixel API to enable you to automatically send event data back
        to Facebook for more efficient ad spend.
      </p>
    ),
    configFields: [{ name: "Pixel ID", key: "pixelId", required: true }],
    eventMappingEventName: "Facebook Standard Event",
    eventMappingConfigKey: "_standardEvents",
    eventMappingSubheader: "Map your events to Standard FB Events",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized. Facebook recognizes{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.facebook.com/docs/facebook-pixel/reference#standard-events"
        >
          certain standard events
        </a>{" "}
        that can be used across custom audiences, custom conversions, conversion
        tracking, and conversion optimization within Facebook. When you map an
        event to a standard Facebook event, we will automatically send the event
        by that name to Facebook. Unmapped events can still be sent to Facebook
        as custom events.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    connectionMode: "server",
    autocompleteMapping: [
      { name: "AddPaymentInfo" },
      { name: "AddToCart" },
      { name: "AddToWishlist" },
      { name: "CompleteRegistration" },
      { name: "Contact" },
      { name: "CustomizeProduct" },
      { name: "Donate" },
      { name: "FindLocation" },
      { name: "InitiateCheckout" },
      { name: "Lead" },
      { name: "PageView" },
      { name: "Purchase" },
      { name: "Schedule" },
      { name: "Search" },
      { name: "StartTrial" },
      { name: "SubmitApplication" },
      { name: "Subscribe" },
      { name: "ViewContent" },
    ],
    getStandardMapping: getFacebookStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  floodlight: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "floodlight",
    name: "Floodlight - DEPRECATED",
    key: "Floodlight",
    type: "advertising",
    logoSquare: FloodlightIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/floodlight",
    configHelp:
      "Enter your Floodlight Advertiser ID. The Advertiser ID will appear on the advertiser details page just below the advertiser's name in Campaign Manager 360. This value is also found as the value of src= in a generated Floodlight tag snippet.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserId", required: true },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        This destination type is deprecated. For{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.google.com/campaignmanager/answer/3027419"
        >
          Floodlight
        </a>{" "}
        conversion and event tracking across the Google Marketing Platform
        (GMP), use the Google Campaign Manager 360 Conversions API destination.
      </p>
    ),
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  freshsales: new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "freshsales",
    name: "Freshsales",
    key: "Freshsales",
    type: "app",
    logoSquare: FreshsalesIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/freshsales",
    configHelp:
      "Your Subdomain is the part of the URL before myfreshworks.com. Your API key can be found by clicking your profile picture > Settings > API Settings.",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Freshsales is a CRM and is part of the broader Freshwork suite. With
        Freshpaint and Freshsales together, you can sync users in Freshpaint to
        contacts and leads in Freshsales.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/freshsales"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      { name: "Subdomain", key: "subdomain", required: true, sensitive: false },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
      {
        name: "Classic",
        key: "classic",
        required: false,
        type: "boolean",
        defaultValue: false,
        description: "Are you using Freshsales classic?",
      },
    ],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  "full-story": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "full-story",
    name: "FullStory",
    key: "FullStory",
    type: "app",
    logoSquare: FullstoryIcon,
    configHelp: "Use the token in your JS snippet to the right of '_fs_org'.",
    configFields: [{ name: "Org ID", key: "org", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  "gainsight-cs": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "gainsight-cs",
    name: "Gainsight CS",
    logoSquare: GainsightIcon,
    type: "app",
    key: "Gainsight CS",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/gainsight-cs",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://www.gainsight.com/customer-success/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Gainsight CS
        </a>{" "}
        is Gainsight&apos;s customer success product. It gives you a complete,
        360-degree view of your customers and helps you understand their product
        behavior based on the data around their interactions and usage trends.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/gainsight-cs"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: <></>,
    configFields: [
      {
        name: "Gainsight Access Key",
        key: "access_key",
        required: true,
        sensitive: true,
        description: (
          <>
            To get the key visit{" "}
            <span style={{ color: "blue" }}>
              {"Administration > Integrations > Connectors 2.0"}
            </span>{" "}
            then click on Gainsight API (you will have to create this connection
            if not done already)
            <br />
            You can also refer to Gainsight&apos;s doc on{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://support.gainsight.com/Gainsight_NXT/Connectors/Connectors/API_Integrations/Generate_API_Access_Key"
              rel="noopener noreferrer"
              target="_blank"
            >
              Access Key
            </a>{" "}
            for more information.
          </>
        ),
      },
      {
        name: "Gainsight Sub-domain or Custom domain",
        placeholder: "your-domain.gainsightcloud.com",
        key: "domain",
        required: true,
        description: (
          <>
            Please enter your gainsight sub-domain or custom domain. This can be
            found under{" "}
            <span style={{ color: "blue" }}>
              {"Administration > General > Domains"}
            </span>
            .
            <br />
            You can also refer to Gainsight&apos;s doc on{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://support.gainsight.com/Gainsight_NXT/06Surveys/02Admin_Guides/Set_up_a_Gainsight_Domain"
              rel="noopener noreferrer"
              target="_blank"
            >
              Gainsight domain
            </a>{" "}
            for more information.
          </>
        ),
      },
      {
        name: "Enable Events",
        key: "events_enabled",
        required: false,
        type: "boolean",
        description: (
          <>
            You&apos;ll need to enable events in Gainsight by visiting the
            Events Page {"("}
            <span style={{ color: "blue" }}>
              {"Administration > General > Events"}
            </span>
            {") "}
            then click Register As Publisher.
            <br />
            You can also refer to Gainsight&apos;s doc on{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://support.gainsight.com/Gainsight_NXT/Journey_Orchestrator_and_Email_Templates/Programs/Events_Framework#Register_as_Publisher"
              rel="noopener noreferrer"
              target="_blank"
            >
              Events Framework
            </a>{" "}
            for more information.
          </>
        ),
      },
      {
        name: "Events Shared Secret Key",
        key: "events_shared_secret_key",
        required: true,
        sensitive: true,
        description: (
          <>
            Visit the Events Page then click on the key / gear icon on the top
            right corner.
          </>
        ),
      },
      {
        name: "Tenant ID",
        key: "tenant_id",
        required: true,
        description: (
          <>
            Visit{" "}
            <span style={{ color: "blue" }}>
              {"Administration > General > Application Settings"}
            </span>{" "}
            to get this.
          </>
        ),
      },
      {
        name: "Event Topic Name",
        key: "event_topic_name",
        required: true,
        description: (
          <>
            Visit the Events Page then create a event topic. You&apos;ll need to
            paste that topic name here.
          </>
        ),
      },
      {
        name: "Contract ID",
        key: "contract_id",
        required: false,
        description: (
          <>
            If a user subscribes to a contract, only those subscribers
            associated with this contract will get the event.{" "}
            <b>This field is optional</b>.
          </>
        ),
      },
      {
        name: "Send User ID as Field on Gainsight",
        key: "send_user_id",
        type: "boolean",
        required: false,
        defaultValue: false,
        description: (
          <>
            When you call{" "}
            <code className="inline text-xs">
              freshpaint.identify(userID, props)
            </code>
            , this option controls if we should send the User ID as a Person
            Field to Gainsight.
          </>
        ),
      },
      {
        name: "User ID Field Name",
        key: "user_id_field_name",
        required: true,
        defaultValue: "ExternalRecordID__gc",
      },
      {
        name: "User Prop <> Gainsight Person Field Mapping",
        key: "person_field_mapping",
        required: false,
        type: "keyValueList",
        defaultValue: [
          // this is same defaults as in Rudderstack
          // see: https://www.rudderstack.com/docs/destinations/streaming-destinations/gainsight/#identify
          {
            key: "email",
            value: "Email",
          },
          { key: "name", value: "Name" },
          { key: "firstName", value: "FirstName" },
          { key: "middleName", value: "MiddleName" },
          { key: "lastName", value: "LastName" },
          { key: "linkedinUrl", value: "LinkedinUrl" },
          { key: "location", value: "Location" },
          { key: "emailOptOut", value: "EmailOptOut" },
          { key: "dynamicResolutionKey", value: "DynamicResolutionKey" },
          { key: "comments", value: "Comments" },
          { key: "timezone", value: "Timezone" },
          { key: "masterRecordId", value: "MasterRecordID" },
          { key: "masterAvatarTypeCode", value: "MasterAvatarTypeCode" },
        ],
        keyValueListLabels: {
          keyLabel: "Freshpaint User Prop",
          valueLabel: "Gainsight Person Field Name",
          objectLabel: "Mapping",
        },
        description: (
          <>
            Note: that sending the <span style={{ color: "blue" }}>Email</span>{" "}
            field is mandatory in gainsight. Without this identify calls will
            fail.
          </>
        ),
      },
      {
        name: "Freshpaint Event <> Gainsight Event Name Mappping",
        key: "event_name_mapping",
        required: false,
        type: "keyValueList",
        defaultValue: [],
        keyValueListLabels: {
          keyLabel: "Freshpaint Event Name",
          valueLabel: "Gainsight Event Name",
          objectLabel: "Mapping",
        },
      },
      {
        name: "Freshpaint Event <> Gainsight Event Version Mapping",
        key: "event_version_mapping",
        required: false,
        type: "keyValueList",
        defaultValue: [],
        keyValueListLabels: {
          keyLabel: "Freshpaint Event Name",
          valueLabel: "Gainsight Event Version",
          objectLabel: "Mapping",
        },
      },
      {
        name: "Send User ID as event property",
        key: "send_user_id_as_event_prop",
        required: false,
        type: "boolean",
        defaultValue: true,
        description: (
          <>
            After enabling, User ID is sent as a property of events sent to
            Gainsight.
          </>
        ),
      },
      {
        name: "User ID Event Property Name",
        key: "user_id_event_prop_name",
        required: true,
        defaultValue: "user_id",
      },
    ],
    customConfig: GainsightCSCustomConfig,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  "google-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "google-ads",
    name: "Google Ads",
    key: "Google AdWords New",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: GoogleAdsIcon,
    supportsMultiConfig: true,
    multiConfigLabel: "Conversion ID",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads",
    configHelp:
      "Enter your Google Conversion ID. You can get this from your global site tag snippet. It should look similar to 302243732.",
    configFields: [
      { name: "Conversion ID", key: "accountId", required: true },
      {
        name: "Google Analytics Account ID",
        required: false,
        key: "gaAccountId",
        description:
          "(Optional) Server-side only. Find your tracking ID under Admin > Property Settings. It should start with UA.",
      },
      {
        name: "Enhanced Ecommerce",
        required: false,
        key: "enhancedEcommerce",
        type: "boolean",
        description: (
          <>
            If you want more detailed reports on ecommerce, you might want to
            enable this feature. Read more about it{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noreferrer noopener"
              href="https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce"
            >
              here
            </a>
            .
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Google is where people search for what to do, where to go, and what to
        buy. Your digital ads can appear on Google at the very moment someone is
        looking for products or services like yours.
      </p>
    ),
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your Google ad spend more efficient & optimized. You can use
        conversion tracking to track when someone clicks a button or link on
        your website, or when someone who’s clicked your ad goes to your website
        and completes an action that you’ve defined as valuable, such as a
        purchase or sign-up.
      </p>
    ),
    eventMappingConfigKey: "_clickConversions",
    eventMappingSubheader:
      "Map your events to Click and Pageview Conversions with Google Ads",
    eventMappingEventName: "Google Conversion Label",
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
    getStandardMapping: getGoogleAdsStandardMapping,
    supportedSources: { web: true, "call-rail": true },
    defaultConsentManagementCategory: "marketing",
  }),
  "google-ads-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "google-ads-audiences",
    name: "Google Ads Audiences",
    key: "Google Ads Audiences",
    type: "app",
    logoSquare: GoogleAdsIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Customer ID",
    supportsTrack: false,
    supportsCohorts: true,
    configHelp: "",
    configFields: [
      {
        name: "Customer ID",
        key: "customerId",
        required: true,
        description: (
          <>
            Enter your Google Ads Account Customer ID. The Customer ID will be
            shown when logged into your google ads account above your email
            address. It should look similar to 123-123-1234. Freshpaint will
            remove the hyphens from this value.
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Google is where people search for what to do, where to go, and what to
        buy. Your digital ads can appear on Google at the very moment someone is
        looking for products or services like yours. This destination allows you
        to create custom audiences on Google which you can use for remarketing
        or lookalike targeting.
      </p>
    ),
    connectionMode: "server",
    customConfig: GoogleAdsAudiencesConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "google-ads-conversion-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "google-ads-conversion-api",
    name: "Google Ads Conversion API",
    key: "Google Ads Conversion API",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: GoogleAdsIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads-conversion-api",
    docsShortName: "Google Ads",
    configHelp: "",
    configFields: [
      {
        name: "Customer ID",
        key: "customerId",
        required: true,
        description: (
          <>
            Enter your Google Ads Account Customer ID. The Customer ID will be
            shown when logged into your google ads account above your email
            address. It should look similar to 123-123-1234.
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Google is where people search for what to do, where to go, and what to
        buy. Your digital ads can appear on Google at the very moment someone is
        looking for products or services like yours.
      </p>
    ),
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your Google ad spend more efficient & optimized. You can use
        conversion tracking to track when someone clicks a button or link on
        your website, or when someone who’s clicked your ad goes to your website
        and completes an action that you’ve defined as valuable, such as a
        purchase or sign-up.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Customer ID",
    connectionMode: "server",
    getStandardMapping: getGoogleAdsStandardMapping,
    customConfig: GoogleAdsConversionAPIConfig,
    defaultConsentManagementCategory: "marketing",
    oauthServiceAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads-conversion-api/google-ads-conversions-api-reference#service-account",
    oauthUserAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads-conversion-api/google-ads-conversions-api-reference#user-account",
  }),
  "google-ads-insights": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "google-ads-insights",
    name: "Google Ads Insights",
    key: "Google Ads Insights",
    type: "advertising",
    logoSquare: GoogleAdsIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Customer ID",
    supportsTrack: false,
    supportsCohorts: false,
    configHelp:
      "Add your Customer ID to connect your Google Ads account to Freshpaint.",
    configBodyHelp: (
      <p className="text-sm">
        The Google Ads Insights destination allows Freshpaint to access your
        Google Ads campaign information and use it to enable the Insights
        Product.
        <br />
        <br />
        This destination is not able to process events and cannot be used to
        send events to Google Ads. If you&apos;re looking to send events to
        Google Ads, please use the Google Ads Conversion API destination
        instead.
      </p>
    ),
    configFields: [
      {
        name: "Customer ID",
        key: "customerId",
        required: true,
        description: (
          <>
            Enter your Google Ads Account Customer ID. The Customer ID will be
            shown when logged into your google ads account above your email
            address. It should look similar to 123-123-1234.
          </>
        ),
      },
    ],
    connectionMode: "server",
    customConfig: GoogleAdsInsightsConfig,
    defaultConsentManagementCategory: "marketing",
    oauthServiceAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads-conversion-api/google-ads-conversions-api-reference#service-account",
    oauthUserAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-ads-conversion-api/google-ads-conversions-api-reference#user-account",
  }),
  "google-cm360-conversion-api": new SaaSDestination({
    destinationCategories: ["Demand side platform"],
    slug: "google-cm360-conversion-api",
    name: "Google Campaign Manager 360 Conversions API",
    key: "Google Campaign Manager 360 Conversions API",
    multiConfigLabel: "Advertiser ID",
    type: "advertising",
    hasEventMapping: true,
    configFields: [
      {
        name: "Profile ID",
        key: "profileId",
        required: true,
        description: (
          <>
            Enter the profile ID for the user or service account that is
            connected to Freshpaint via OAuth. This can be found in CM360 on the
            "User profiles" tab under Admin.
          </>
        ),
      },
      {
        name: "Advertiser ID",
        key: "advertiserId",
        required: true,
        description: (
          <>
            Enter your Campaign Manager 360 Advertiser ID. This can be found
            under Advertisers in CM360, and will also be shown in Campaign and
            Floodlight configurations.
          </>
        ),
      },
      {
        name: "Enable sending GCLID",
        key: "enableGclid",
        required: true,
        description: (
          <>
            If enabled, Freshpaint will send conversion events to CM360 using
            the $gclid parameter if present in the event. If you have no google
            ads accounts connected to CM360, you can disable this setting to
            avoid attempting to send conversion events that google will not
            recognize.
          </>
        ),
      },
    ],
    logoSquare: GoogleCampaignManager360Icon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-campaign-manager-360",
    docsShortName: "Google CM360",
    configHelp: "",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend through Google Campaign Manager 360 more efficient &
        optimized. You can use conversion tracking to track when someone clicks
        a button or link on your website, or when someone who’s clicked your ad
        goes to your website and completes an action that you’ve defined as
        valuable, such as a purchase or sign-up.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $edimpid: "%edimpid!",
    },
    connectionMode: "server",
    customConfig: GoogleCampaignManager360Config,
    oauthServiceAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-campaign-manager-360#service-account",
    oauthUserAccountHelpURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/google-campaign-manager-360#user-account",
  }),
  "google-tag-manager": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "google-tag-manager",
    name: "Google Tag Manager",
    key: "Google Tag Manager",
    type: "app",
    hasEventMapping: false,
    logoSquare: GoogleTagManagerIcon,
    configHelp:
      "Enter your Google Conversion ID. You can get this from your global site tag snippet. It should look similar to GTM-XXXXXXX.",
    configFields: [
      {
        name: "Container ID",
        key: "containerId",
        required: true,
        description: (
          <>
            Your Container ID from your{" "}
            <a
              href="https://tagmanager.google.com/#/home"
              className="underline"
              style={{ color: "blue" }}
              rel="noopener noreferrer"
              target="_blank"
            >
              GTag Accounts page
            </a>
            .
          </>
        ),
      },
      {
        name: "Environment",
        key: "environment",
        required: false,
        description: (
          <>
            (Optional) Your environment variable for gtm previews. IMPORTANT:
            make sure the string includes gtm_auth. For example, your string
            should look like <code>env-xx&gtm_auth=xxxxxx</code>
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        <a
          href="https://marketingplatform.google.com/about/tag-manager/?utm_source=segment&utm_medium=integrations-page&utm_campaign=partners"
          className="underline"
          style={{ color: "blue" }}
          rel="noopener noreferrer"
          target="_blank"
        >
          Google Tag Manager
        </a>{" "}
        is a{" "}
        <a
          href="https://en.wikipedia.org/wiki/Tag_management_system"
          className="underline"
          style={{ color: "blue" }}
          rel="noopener noreferrer"
          target="_blank"
        >
          tag management system (TMS)
        </a>{" "}
        that allows you to quickly and easily update measurement codes and
        related code fragments collectively known as tags on your website or
        mobile app.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  "google-ads-remarketing-lists": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "google-ads-remarketing-lists",
    name: "Google Ads Remarketing Lists",
    key: "Google Ads Remarketing Lists",
    type: "cohorting",
    logoSquare: GoogleAdsIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: false,
    supportsCohorts: true,
    configHelp: (
      <>
        You can get your Customer ID by signing into your{" "}
        <a href="https://ads.google.com">Google Ads account</a>, clicking the
        help icon in the top right corner, and finding the "Customer ID" at the
        bottom of the menu.
      </>
    ),
    configFields: [
      { name: "Customer ID", key: "customerId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: GoogleAdsRemarketingListsConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "google-analytics": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "google-analytics",
    name: "Google Analytics 3 (Universal Analytics)",
    key: "Google Analytics",
    type: "app",
    logoSquare: GoogleAnalyticsIcon,
    configHelp:
      "Find your tracking ID under Admin > Property Settings. It should start with UA.",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/destinations/apps/google-analytics-3-universal-analytics"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    customConfig: GACustomConfig,
    configFields: [
      { name: "Tracking ID", key: "trackingId", required: true },
      {
        name: "Site Speed Sample Rate",
        key: "siteSpeedSampleRate",
        required: true,
        type: "number",
        description: (
          <>
            Specifies what percentage of users should be sampled for Site Speed
            metrics. If you have a small number of visitors you might want to
            adjust the sampling to a larger rate for your site speed stats.
          </>
        ),
      },
      {
        name: "Sampling Rate",
        key: "sampleRate",
        required: true,
        type: "number",
        description: (
          <>
            Specifies what percentage of users should be tracked. This defaults
            to 100 (all users are sampled) but high-traffic sites should use a
            lower sample rate to adhere to Google Analytics processing limits as{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#sampleRate"
            >
              seen here
            </a>
            .
          </>
        ),
      },
      {
        name: "Name Tracker",
        key: "nameTracker",
        required: false,
        type: "boolean",
        description: (
          <>
            Names the tracker{" "}
            <code className="text-xs">freshpaintGATracker</code> if enabled. Use
            this if you&apos;re working with additional GA trackers and want to
            ensure that your Freshpaint tracker name is distinct. If this is
            enabled you must prepend this tracker name to any native Google
            Analytics (except for <code className="text-xs">create</code>) that
            you call, e.g.
            <code className="text-xs">freshpaintGATracker.require(....)</code>
          </>
        ),
      },
      {
        name: "Enhanced Ecommerce",
        required: false,
        key: "enhancedEcommerce",
        type: "boolean",
        description: (
          <>
            If you want more detailed reports on ecommerce, you might want to
            enable this feature. Read more about it{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noreferrer noopener"
              href="https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce"
            >
              here
            </a>
            .
          </>
        ),
      },
      {
        name: "Anonymize IP Addresses",
        required: false,
        key: "anonymizeIp",
        type: "boolean",
        description: (
          <>
            If enabled, IP addresses will be anonymized on the client side. Read
            more about anonymizing IP addresses from the{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noreferrer noopener"
              href="https://support.google.com/analytics/answer/2763052?hl=en"
            >
              Google support documentation
            </a>
            .
          </>
        ),
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
    defaultConsentManagementCategory: "analytics",
  }),
  "google-analytics-4": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "google-analytics-4",
    name: "Google Analytics 4 (Server-Side)",
    key: "Google Analytics 4",
    type: "app",
    logoSquare: GoogleAnalyticsIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4",
    configHelp: (
      <>
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Google Analytics 4 is an analytics service that enables you to measure
        traffic and engagement across your websites and apps.
        <br />
        <br />
        This server-side integration sends events directly to GA4 Web Streams
        using the Measurement Protocol. For mobile app events (iOS/Android), use
        the <b>Google Analytics 4 (Proxy)</b> integration instead.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      {
        name: "Measurement ID",
        key: "measurementId",
        required: true,
        placeholder: "G-XXXXXXXXXX",
        description: (
          <>
            Found in the Google Analytics UI under: Admin &gt; Data Streams &gt;
            Web &gt; Measurement ID. Format: <code>G-XXXXXXXXXX</code>
          </>
        ),
      },
      {
        name: "API Secret",
        key: "apiKey",
        required: true,
        sensitive: true,
        description: (
          <>
            An <code>API SECRET</code> is generated in the Google Analytics UI.
            To create a new secret, navigate to: Admin &gt; Data Streams &gt;
            choose your stream &gt; Measurement Protocol &gt; Create
          </>
        ),
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Stream ID",
    connectionMode: "server",
    defaultConsentManagementCategory: "analytics",
  }),
  "google-analytics-4-proxy": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "google-analytics-4-proxy",
    name: "Google Analytics 4 (Proxy)",
    key: "Google Analytics 4 Proxy",
    type: "app",
    logoSquare: GoogleAnalyticsProxyIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4-proxy",
    configHelp: (
      <>
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4-proxy"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
        <br />
        <br />
        Warning: If you have multiple configurations, see the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/google-analytics-4-proxy/google-analytics-4-proxy-multi-config-reference"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint GA4 Multi-Config Documentation
        </a>{" "}
        for more details and assistance on setup.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Google Analytics 4 is an analytics service that enables you to measure
        traffic and engagement across your websites and apps.
        <br />
        <br />
        The Google Analytics 4 Proxy integration behaves like a client-side
        installation of Google Analytics 4, except the data is first routed
        through the Freshpaint servers. Choose your stream type below.
      </p>
    ),
    configName: "Base Configuration",
    configFields: [
      {
        name: "Stream Type",
        key: "streamType",
        type: "radio",
        required: false,
        options: [
          { value: "web", label: "Web Stream (for websites)" },
          { value: "app", label: "App Stream (for iOS/Android apps)" },
        ],
        defaultValue: "web",
        // Derive stream type from existing config (for configs created before this UI change)
        mapConfigValueToControlValue: (value, allSettings) => {
          // If streamType is already set, use it
          if (value) return value;
          // If firebaseAppId is set, this is an App Stream config
          if (allSettings?.firebaseAppId) return "app";
          // Default to web
          return "web";
        },
        description: (
          <>
            Choose <b>Web Stream</b> for website events, or <b>App Stream</b>{" "}
            for mobile app events that should appear in your Firebase/GA4 app
            property.
          </>
        ),
      },
      {
        name: "Measurement ID",
        key: "measurementId",
        required: false,
        placeholder: "G-XXXXXXXXXX",
        visibleWhen: { field: "streamType", value: "web" },
        requiredWhen: { field: "streamType", value: "web" },
        description: (
          <>
            Found in the Google Analytics UI under: Admin &gt; Data Streams &gt;
            Web &gt; Measurement ID. Format: <code>G-XXXXXXXXXX</code>
          </>
        ),
      },
      {
        name: "Firebase App ID",
        key: "firebaseAppId",
        required: false,
        placeholder: "1:123456789:ios:abc123def456",
        visibleWhen: { field: "streamType", value: "app" },
        requiredWhen: { field: "streamType", value: "app" },
        description: (
          <>
            Found in your Firebase project settings or Google Analytics UI
            under: Admin &gt; Data Streams &gt; iOS/Android app.
            <br />
            Format: <code>1:123456789:ios:abc123def456</code>
          </>
        ),
      },
      {
        name: "API Secret",
        key: "apiSecret",
        required: false,
        sensitive: true,
        requiredWhen: { field: "streamType", value: "app" },
        description: (
          <>
            <b>Required for App Streams only.</b> Generated in the Google
            Analytics UI: Admin &gt; Data Streams &gt; choose your stream &gt;
            Measurement Protocol &gt; Create
          </>
        ),
      },
      {
        name: "App Instance ID (Optional)",
        key: "appInstanceIdProperty",
        required: false,
        placeholder: "$firebase_app_instance_id or static ID",
        visibleWhen: { field: "streamType", value: "app" },
        description: (
          <>
            Enter either a <b>property name</b> (e.g.,{" "}
            <code>$firebase_app_instance_id</code>) to read from events, or a{" "}
            <b>static App Instance ID</b> for testing. Leave blank to
            auto-detect from common properties.
          </>
        ),
      },
      {
        name: "Send Page View Event",
        key: "sendPageView",
        type: "boolean",
        required: false,
        defaultValue: true,
        visibleWhen: { field: "streamType", value: "web" },
        description: (
          <>
            Automatically send page_view events. Warning: disabling this event
            can cause the GA4 builtin dashboard to produce unexpected results.
          </>
        ),
      },
      {
        name: "Send Scroll Event",
        key: "sendScroll",
        type: "boolean",
        required: false,
        defaultValue: true,
        visibleWhen: { field: "streamType", value: "web" },
        description: (
          <>
            Automatically send scroll events. Warning: disabling this event can
            cause the GA4 builtin dashboard to produce unexpected results.
          </>
        ),
      },
      {
        name: "Send User Engagement Event",
        key: "sendUserEngagement",
        type: "boolean",
        required: false,
        defaultValue: true,
        visibleWhen: { field: "streamType", value: "web" },
        description: (
          <>
            Automatically send user_engagement events. Warning: disabling this
            event can cause the GA4 builtin dashboard to produce unexpected
            results.
          </>
        ),
      },
      {
        name: "Send Video Engagement Event",
        key: "sendVideoEngagement",
        type: "boolean",
        required: false,
        visibleWhen: { field: "streamType", value: "web" },
        description: (
          <>
            Automatically send video_start/video_progress/video_complete events.
          </>
        ),
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Stream ID",
    connectionMode: "server",
    supportedSources: {
      web: true,
      "call-rail": true,
      "analytics-ios": true,
      "analytics-android": true,
    },
    defaultConsentManagementCategory: "analytics",
  }),
  "google-pubsub": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "google-pubsub",
    name: "Google PubSub",
    key: "Google PubSub",
    type: "app",
    logoSquare: GoogleCloudPubSubIcon,
    configHelp: (
      <>
        Allow Freshpaint to publish events to a Pub/Sub topic on your behalf by
        adding <code>pubsub@freshpaint-1.iam.gserviceaccount.com</code> as a
        Pub/Sub publisher in your{" "}
        <a href="https://console.cloud.google.com/cloudpubsub/topicList">
          Google Cloud Console
        </a>
        .
      </>
    ),
    configFields: [
      {
        name: "Mappings",
        key: "eventTopicMappings",
        required: true,
        type: "keyValueList",
        defaultValue: [],
        keyValueListLabels: {
          keyLabel: "Event Name",
          valueLabel: "Topic Name",
          objectLabel: "Mapping",
        },
      },
    ],
    hasEventMapping: false,
    customConfig: GooglePubSubCustomConfig,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
    isFpEmployeeOnly: true,
  }),
  "go-squared": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "go-squared",
    name: "GoSquared",
    key: "GoSquared",
    type: "app",
    logoSquare: GosquaredIcon,
    configHelp: "Your project token can be found under 'code free setup'.",
    configFields: [{ name: "Project Token", key: "apiSecret", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  heap: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "heap",
    name: "Heap",
    key: "Heap",
    type: "app",
    logoSquare: HeapIcon,
    configHelp:
      "Find the App ID on your Account Projects page for a specific Environment.",
    configFields: [{ name: "App ID", key: "appId", required: true }],
    supportsBackfill: true,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
    defaultConsentManagementCategory: "analytics",
  }),
  "hello-bar": new SaaSDestination({
    destinationCategories: ["Data activation"],
    deprecated: true,
    slug: "hello-bar",
    name: "Hello Bar",
    key: "Hello Bar",
    type: "app",
    logoSquare: HellobarIcon,
    configHelp: "The key is to the right of my.hellobar.com in the JS script.",
    configFields: [{ name: "API Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  hotjar: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "hotjar",
    name: "Hotjar",
    key: "Hotjar",
    type: "app",
    logoSquare: HotjarIcon,
    configHelp: "Your Site ID is on the left of Settings > Sites & Orgs",
    configFields: [{ name: "App ID", key: "hjid", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  "hubspot-cloud": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "hubspot-cloud",
    name: "HubSpot Cloud",
    key: "HubSpot Cloud",
    type: "app",
    logoSquare: HubspotIcon,
    configHelp:
      "Find your access token by creating a private app with the crm.objects.contacts read and write permissions and the analytics.behavioral_events.send permission.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/hubspot-cloud",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        HubSpot is a CRM - it lets you keep track of all your customer leads.
        With the Freshpaint-HubSpot integration, you can create leads in HubSpot
        and send events to HubSpot based on your Freshpaint data.
        <br />
        <br />
        Compared to the HubSpot Web destination this destination runs
        server-side. In general we recommend using this destination when
        possible.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/hubspot-cloud"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      {
        name: "Access Token",
        key: "accessToken",
        required: true,
        sensitive: true,
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
  }),
  hubspot: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "hubspot",
    name: "HubSpot Web",
    key: "HubSpot",
    type: "app",
    logoSquare: HubspotIcon,
    configHelp: "Find your Hub ID under the account dropdown.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/hubspot-web",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        HubSpot is a CRM - it lets you keep track of all your customer leads.
        With the Freshpaint-HubSpot integration, you can create leads in HubSpot
        and send events to HubSpot based on your Freshpaint data.
        <br />
        <br />
        Compared to the HubSpot web destination, this destination only supports
        data from the web source. In general we recommend using the HubSpot
        Cloud destination when possible.
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/destinations/apps/hubspot-web"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [{ name: "Hub ID", key: "portalId", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
    defaultConsentManagementCategory: "marketing",
  }),
  impactdotcom: new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "impactdotcom",
    name: "impact.com",
    key: "impactdotcom",
    logoSquare: ImpactRadiusIcon,
    type: "advertising",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/impactdotcom",
    configHelp: (
      <>
        See the{" "}
        <a href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/impactdotcom">
          Freshpaint Documentation
        </a>{" "}
        for more details.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/impactdotcom"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      {
        name: "Account SID",
        key: "accountSid",
        required: true,
      },
      {
        name: "API Key",
        key: "apiKey",
        required: true,
        sensitive: true,
      },
      {
        name: "Campaign ID",
        key: "campaignId",
        type: "number",
        required: true,
      },
    ],
    supportsServerSide: true,
    // impact does not accept timestamps > 7 days old
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "server",
  }),
  inspectlet: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "inspectlet",
    name: "Inspectlet",
    key: "Inspectlet",
    type: "app",
    logoSquare: InspectletIcon,
    configHelp: "Your WID is the big number at the start of the JS snippet.",
    configFields: [{ name: "WID", key: "wid", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  intercom: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "intercom",
    name: "Intercom",
    key: "Intercom",
    type: "app",
    logoSquare: IntercomIcon,
    configHelp:
      "Please refer to Freshpaint documentation for more information.",
    configFields: [
      // This needs to be true for the server side event tracker to show up.
      {
        name: "accountID",
        key: "appId",
        required: true,
        description:
          "Only used in client-side integrations. Put a dummy value here if you are doing a server-side integration.",
      },
      {
        name: "API Key",
        key: "apiKey",
        required: false,
        sensitive: true,
        description: "(Optional) Only used in server-side integrations.",
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "client",
  }),
  iterable: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "iterable",
    name: "Iterable",
    key: "Iterable",
    type: "app",
    logoSquare: IterableIcon,
    configHelp:
      "You can create a Server-side API Key under Destinations > API Keys",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/iterable",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Create personalized messaging campaigns for your customers. Attach
        customer metadata from Freshpaint to the user profiles in your Iterable
        project.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/iterable"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configName: "Credentials",
    configFields: [
      {
        name: "Server-side API Key",
        key: "apiKey",
        required: true,
        sensitive: true,
      },
      {
        key: "defaultIdentifyTransformations",
        name: "Enable Default Identify Transformations",
        required: false,
        sensitive: false,
        defaultValue: false,
        type: "boolean",
        description: (
          <>
            Changing this setting will break historical data, so only enable
            this if you&apos;re setting up a new Iterable project.
            <br />
            Enable this setting to have freshpaint apply a default set of
            transformations to identify calls.
          </>
        ),
      },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  keen: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "keen",
    name: "Keen IO",
    key: "Keen IO",
    type: "app",
    logoSquare: KeenIoIcon,
    configHelp: "Find your keys under Installation > JavaScript.",
    configName: "Keys",
    configFields: [
      { name: "Project ID", key: "projectId", required: true },
      {
        name: "Write Key",
        key: "writeKey",
        required: true,
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  kissmetrics: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "kissmetrics",
    name: "KISSmetrics",
    key: "KISSmetrics",
    type: "app",
    logoSquare: KissmetricsIcon,
    configHelp: "Find your API Key under Settings > Product Settings.",
    configFields: [{ name: "Tracking API Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  klaviyo: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "klaviyo",
    name: "Klaviyo",
    key: "Klaviyo",
    type: "app",
    logoSquare: KlaviyoIcon,
    configName: "Settings",
    configHelp:
      "Find your public API Key under Account > Settings > API Keys. ",
    configFields: [
      {
        name: "Public API Key",
        key: "apiKey",
        required: true,
      },
      {
        name: "Use Email as Identifier",
        key: "useEmailID",
        type: "boolean",
        required: false,
        defaultValue: true,
        description:
          "If the Freshpaint identifier is an email, the identifier will be sent as the user's email instead of as their id.",
      },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "client",
  }),
  kochava: new SaaSDestination({
    destinationCategories: ["MMP"],
    slug: "kochava",
    name: "Kochava",
    key: "Kochava",
    type: "app",
    logoSquare: KochavaIcon,
    configHelp:
      "The API Key and App Secret are only required if the Kochava Install Authentication feature is enabled for your Kochava account. If provided, Freshpaint will sign every request with these credentials. Both must be provided together.",
    configFields: [
      { name: "Kochava App ID", key: "kochava_app_id", required: true },
      {
        name: "Kochava API Key",
        key: "kochava_api_key",
        required: false,
        sensitive: true,
      },
      {
        name: "Kochava App Secret",
        key: "kochava_app_secret",
        required: false,
        sensitive: true,
      },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Kochava App ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  kustomer: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "kustomer",
    name: "Kustomer",
    key: "Kustomer",
    type: "app",
    logoSquare: KustomerIcon,
    configHelp:
      "You can access API Keys settings page by going to Settings > Security > API Keys. The API key will need the 'org.tracking' role.",
    configFields: [
      { name: "API key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
  }),
  "lead-squared": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "lead-squared",
    name: "LeadSquared",
    key: "LeadSquared",
    type: "app",
    logoSquare: LeadSquaredIcon,
    configName: "Settings",
    configHelp:
      "Find your keys by going to My Account > Settings > API and Webhooks.",
    configFields: [
      {
        name: "Host",
        key: "host",
        required: true,
        description: `This should be either 'api', 'api-us11', or 'api-in21'.`,
      },
      {
        name: "Access Key",
        key: "accessKey",
        required: true,
        sensitive: true,
      },
      {
        name: "Secret Key",
        key: "secretKey",
        required: true,
        sensitive: true,
      },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  "linkedin-tag": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "linkedin-tag",
    name: "LinkedIn Tag",
    key: "LinkedIn Insight Tag",
    type: "advertising",
    logoSquare: LinkedinIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The LinkedIn Insight Tag integration in Freshpaint enables in-depth
        campaign reporting and unlocks valuable insights about your site
        visitors. This lets you track conversions, retarget website visitors,
        and unlock additional insights about LinkedIn members interacting with
        your ads.
      </p>
    ),
    configHelp:
      "Enter your Linkedin Data Partner ID. It is a series of numbers.",
    configFields: [{ name: "Partner ID", key: "partnerId", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: false,
    connectionMode: "client",
    defaultConsentManagementCategory: "marketing",
  }),
  "linkedin-ads-conversions-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "linkedin-ads-conversions-api",
    name: "LinkedIn Ads Conversions API",
    key: "LinkedIn Ads Conversions API",
    type: "advertising",
    logoSquare: LinkedinIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The LinkedIn Ads Conversions API integration in Freshpaint enables a
        HIPAA compliant method for LinkedIn campaign conversion events.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/direct-response-ads/linkedin-ads-conversions-api"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: (
      <>
        Configure conversion events using Transformations or Event Definition
        dynamic properties.
        <br />
        Each conversion event must have a{" "}
        <code className="inline text-xs">conversion_id</code> property matching
        the relevant Conversion Event Rule ID.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/direct-response-ads/linkedin-ads-conversions-api/linkedin-ads-conversions-api-quick-start-guide"
          rel="noopener noreferrer"
          target="_blank"
        >
          LinkedIn Ads Conversions API destination quick start guide
        </a>{" "}
        for more details.
        <br />
        <br />
        Please click the{" "}
        <span style={{ color: "blue", fontWeight: "bold" }}> SAVE </span> button
        below to configure this destination.
      </>
    ),
    configFields: [],
    customConfig: LinkedInAdsConversionsAPICustomConfig,
    supportsMultiConfig: true,
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "linkedin-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "linkedin-audiences",
    name: "LinkedIn Audiences",
    key: "LinkedIn Audiences",
    type: "app",
    logoSquare: LinkedinIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The LinkedIn Audiences integration enables syncing Freshpaint audiences
        to LinkedIn DMP Segments for ad targeting.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/audiences/audience-integrations/linkedin-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: "Enter your LinkedIn Ad Account ID.",
    configFields: [
      { name: "Ad Account ID", key: "adAccountId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    customConfig: LinkedInAudiencesConfig,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "linkedin-insights": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "linkedin-insights",
    name: "LinkedIn Insights",
    key: "LinkedIn Insights",
    type: "advertising",
    logoSquare: LinkedinIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsTrack: false,
    supportsCohorts: false,
    configHelp:
      "Add your Ad Account ID to connect your LinkedIn Insights account to Freshpaint.",
    configBodyHelp: (
      <p className="text-sm">
        The LinkedIn Insights destination allows Freshpaint to access your
        LinkedIn Ads campaign information and use it to enable the Insights
        Product.
        <br />
        <br />
        This destination is not able to process events and cannot be used to
        send events to LinkedIn. If you&apos;re looking to send events to
        LinkedIn, please use the LinkedIn Ads Conversions API destination
        instead.
      </p>
    ),
    configFields: [
      {
        name: "Ad Account ID",
        key: "adAccountID",
        required: true,
        sensitive: false,
      },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: LinkedInInsightsConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "live-chat": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "live-chat",
    name: "LiveChat",
    key: "LiveChat",
    type: "app",
    logoSquare: LivechatIcon,
    configHelp: "Your token is the number in your JS script after '.license'. ",
    configFields: [{ name: "Token", key: "license", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "lucky-orange": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "lucky-orange",
    name: "Lucky Orange",
    key: "Lucky Orange",
    type: "app",
    logoSquare: LuckyOrangeIcon,
    configHelp: "Find your Site ID on the settings page. ",
    configFields: [{ name: "Site ID", key: "siteId", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "meta-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "meta-audiences",
    name: "Meta Audiences",
    key: "Meta Audiences",
    type: "app",
    logoSquare: Meta,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsTrack: false,
    configHelp: (
      <>
        You can get your Ad Account ID by going to the{" "}
        <a href="https://business.facebook.com/settings">
          Facebook Business Settings
        </a>
        , clicking Ad Accounts, and copying your Ad Account ID at the top of the
        page.
      </>
    ),
    configFields: [
      { name: "Ad Account ID", key: "adAccountID", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: MetaOAuthCustomConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "meta-insights": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "meta-insights",
    name: "Meta Insights",
    // Old name of "Meta Ad Performance" is kept on the backend for backwards compatibility.
    key: "Meta Ad Performance",
    type: "advertising",
    logoSquare: Meta,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsTrack: false,
    supportsCohorts: false,
    configHelp: (
      <>
        You can get your Ad Account ID by going to the{" "}
        <a href="https://business.facebook.com/settings">
          Facebook Business Settings
        </a>
        , clicking Ad Accounts, and copying your Ad Account ID at the top of the
        page.
      </>
    ),
    configBodyHelp: (
      <p className="text-sm">
        The Meta Insights destination allows Freshpaint to access your Meta
        campaign information and use it to enable the Insights Product.
        <br />
        <br />
        This destination is not able to process events and cannot be used to
        send events to Meta. If you&apos;re looking to send events to Meta,
        please use the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/direct-response-ads/facebook-conversions-api"
          rel="noopener noreferrer"
          target="_blank"
        >
          Facebook Conversions API
        </a>{" "}
        destination instead.
      </p>
    ),
    configFields: [
      { name: "Ad Account ID", key: "adAccountID", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: MetaOAuthCustomConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "microsoft-ads-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "microsoft-ads-audiences",
    name: "Microsoft Ads Audiences",
    key: "Microsoft Ads Audiences",
    type: "advertising",
    logoSquare: MicrosoftIcon,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/audiences/audience-integrations/microsoft-ads-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp:
      "Enter your Microsoft Ads Audiences Account ID and Customer ID. You can find these by logging into the Microsoft Ads UI and looking for aid= and cid= in the URL.",
    configFields: [
      { name: "Account ID", key: "accountId", required: true },
      { name: "Customer ID", key: "customerId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    customConfig: MicrosoftAdsAudiencesConfig,
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: true,
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Account ID",
    defaultConsentManagementCategory: "marketing",
  }),
  "microsoft-ads-conversions-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "microsoft-ads-conversions-api",
    name: "Microsoft Ads Conversions API",
    key: "Microsoft Ads Conversions API",
    type: "app",
    logoSquare: MicrosoftIcon,
    configHelp:
      "Provide your Microsoft Ads UET Tag ID and Conversion Access Token. These can be found in the Microsoft Ads Manager.",
    configFields: [
      { name: "Tag ID", key: "tagId", required: true },
      { name: "Token", key: "token", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Tag ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  mixpanel: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "mixpanel",
    name: "Mixpanel",
    key: "Mixpanel",
    type: "app",
    logoSquare: MixpanelIcon,
    configHelp: "Find your keys under your project's settings page.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/mixpanel",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Mixpanel is the classic Analytics tool for event tracking, segmentation,
        and reporting. After sending Freshpaint data to Mixpanel, you&apos;ll be
        able to analyze the data and produce charts and graphs of your product
        data.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/mixpanel"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configName: "Settings",
    configFields: [
      { name: "Token", key: "token", required: true, sensitive: true },
      {
        name: "API Secret",
        key: "secret",
        sensitive: true,
        required: true,
      },
      {
        name: "Group Identifier Traits",
        key: "groupIdentifierTraits",
        required: false,
        sensitive: false,
        description:
          'The traits Freshpaint should use as your Mixpanel "group key" in group calls.',
        type: "list",
        defaultValue: [],
      },
      {
        name: "Cross Subdomain Cookie",
        description:
          "This allows the Mixpanel cookie to persist between subdomains on your application.",
        key: "crossSubdomainCookie",
        required: false,
        sensitive: false,
        type: "boolean",
      },
      {
        name: "Use Local Storage",
        description:
          "Use Local Storage instead of a Cookie to persist Mixpanel SDK state. " +
          "Local Storage can support more User Property data than a cookie. " +
          "Please note that users cannot be tracked across Subdomains when using Local Storage.",
        key: "persistence",
        required: false,
        sensitive: false,
        type: "boolean",
        mapControlValueToConfigValue: (isLocalStorage) =>
          isLocalStorage ? "localStorage" : "cookie",
        mapConfigValueToControlValue: (configValue) =>
          configValue === "localStorage",
        defaultValue: false,
      },
      {
        name: "Enable EU Endpoint",
        key: "enableEuropeanUnionEndpoint",
        required: false,
        sensitive: false,
        type: "boolean",
        description: (
          <>
            When enabled, Freshpaint will send your events to Mixpanel&apos;s{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://developer.mixpanel.com/docs/implement-mixpanel#section-implementing-mixpanel-in-the-european-union-eu"
            >
              EU endpoint
            </a>
            . In Mixpanel, be sure to enable Data Residency under{" "}
            <b className="text-xs">Project Settings</b> &gt;{" "}
            <b className="text-xs">Set up Mixpanel</b> &gt;{" "}
            <b className="text-xs">Data Residency.</b> Make sure you&apos;ve
            followed{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.mixpanel.com/hc/en-us/articles/360039135652-Data-Residency-in-EU"
            >
              Mixpanel&apos;s help article
            </a>{" "}
            to set up EU data.
          </>
        ),
      },
      {
        name: "Secure Cookie",
        key: "secureCookie",
        required: false,
        sensitive: false,
        type: "boolean",
        description:
          "This use a secure cookie, meaning it will only be transmitted over https",
      },
      {
        name: "Consolidate Page Calls",
        key: "consolidatedPageCalls",
        required: false,
        sensitive: false,
        defaultValue: false,
        type: "boolean",
        description: (
          <>
            This will send a <b>Loaded a Page</b> event to Mixpanel for all{" "}
            <code className="inline">page()</code> method calls.
          </>
        ),
      },
      {
        name: "Ignore DNT",
        key: "ignore_dnt",
        required: false,
        sensitive: false,
        type: "boolean",
        defaultValue: true,
        description: (
          <>
            When enabled, Mixpanel will track all events, regardless of if the
            browser has "Do Not Track" enabled.{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.eff.org/issues/do-not-track"
            >
              Learn More About DNT
            </a>
            .
          </>
        ),
      },
      {
        name: "Merge Anonymous",
        key: "mergeAnonymous",
        required: false,
        sensitive: false,
        type: "boolean",
        defaultValue: true,
        description:
          "Merge anonymous users with identified users when a server-side identify call is performed.",
      },
      {
        key: "preferAnonymousIdForDeviceId",
        name: "Use Freshpaint ID for Device ID",
        required: false,
        sensitive: false,
        defaultValue: false,
        type: "boolean",
        description: (
          <>
            Changing this setting will break historical data, so only enable
            this if you're setting up a new Mixpanel project.
            <br />
            Enable this setting to make the Mixpanel javascript web SDK use the
            Freshpaint device ID. This improves data consistency - you'll see
            the same device id for data streamed from your customers' web
            browsers as for data backfilled from freshpaint's servers.
          </>
        ),
      },
      {
        key: "defaultIdentifyTransformations",
        name: "Enable Default Identify Transformations",
        required: false,
        sensitive: false,
        defaultValue: true,
        type: "boolean",
        description: (
          <>
            Changing this setting will break historical data, so only enable
            this if you&apos;re setting up a new Mixpanel project.
            <br />
            Enable this setting to have freshpaint apply a default set of
            transformations to identify calls.
          </>
        ),
      },
    ],
    customConfig: MixpanelCustomConfig,
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Instance ID",
    connectionMode: "client",
    defaultConsentManagementCategory: "analytics",
  }),
  mntn: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "mntn",
    name: "MNTN",
    key: "MNTN",
    type: "app",
    logoSquare: MntnIcon,
    configName: "Base Configuration",
    configHelp:
      "Your MNTN Advertiser ID, which may also be referred to as Customer Identification ID, is the number in parenthesis beside your account name in the top right of the MNTN dashboard.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserId", required: true },
      {
        name: "Send page view events as Verified Visits by default",
        key: "sendPageViewsAsVisits",
        type: "boolean",
        required: false,
        defaultValue: true,
        description: (
          <>
            Default to sending page view events as{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://mountain.com/blog/how-mntn-measures-performance-without-clicks-a-deep-dive-into-the-verified-visits-model/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Verified Visits
            </a>{" "}
            to MNTN for improved conversion tracking. See the{" "}
            <a
              className="underline"
              style={{ color: "blue" }}
              href="https://documentation.freshpaint.io/integrations/destinations/demand-side-platforms-dsps/mntn/mntn-quick-start-guide"
              rel="noopener noreferrer"
              target="_blank"
            >
              quick start guide
            </a>{" "}
            for more information about Verified Visits and event configuration.
          </>
        ),
      },
    ],
    supportsServerSide: true,
    supportsBackfill: false,
    supportsTrack: true,
    supportsImpressionPixel: true,
    impressionPixelParams: {
      // eslint-disable-next-line no-template-curly-in-string
      $mntn_impid: "${asid}",
    },
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    defaultConsentManagementCategory: "marketing",
  }),
  mouseflow: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "mouseflow",
    name: "Mouseflow",
    key: "Mouseflow",
    type: "app",
    logoSquare: MouseFlowIcon,
    configHelp: "Find your Website ID on the settings page.",
    configFields: [{ name: "Website ID", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  mousestats: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "mousestats",
    name: "MouseStats",
    key: "MouseStats",
    type: "app",
    logoSquare: MouseStatsIcon,
    configHelp: "Find your Account ID in the top right of the tracking script.",
    configFields: [
      { name: "Account ID", key: "accountNumber", required: true },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  olark: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "olark",
    name: "Olark",
    key: "Olark",
    type: "app",
    logoSquare: OlarkIcon,
    configHelp: "Your Site ID is in quotes at the end of your JS script.",
    configFields: [{ name: "Site ID", key: "siteId", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  "one-signal": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "one-signal",
    name: "OneSignal",
    key: "OneSignal",
    type: "app",
    logoSquare: OnesignalIcon,
    configHelp: "Your App ID can be found under Settings > Keys and IDs.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/one-signal",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        With Freshpaint and OneSignal, you can can use Freshpaint to attach user
        metadata to your users in OneSignal and create customized messaging
        campaigns for your customers.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/one-signal"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [{ name: "App ID", key: "appId", required: true }],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: false,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  parsely: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "parsely",
    name: "Parsely",
    key: "Parsely",
    type: "app",
    logoSquare: ParselyIcon,
    configHelp: "Enter the domain you are using with Parse.ly.",
    configFields: [{ name: "Domain", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  pingdom: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "pingdom",
    name: "Pingdom",
    key: "Pingdom",
    type: "app",
    logoSquare: PingdomIcon,
    configHelp: "Your ID is after 'pingdom.net/pa' in your RUM JS script.",
    configFields: [{ name: "RUM ID", key: "id", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "pinterest-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "pinterest-ads",
    name: "Pinterest Ads",
    key: "pinterest-ads",
    type: "advertising",
    logoSquare: PinterestIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The Pinterest Ads integration in Freshpaint enables a HIPAA compliant
        method for Pinterest ad conversion events.
        <br />
        <br />
        For view-through conversion tracking, Pinterest requires a minimum of
        either email, or a combination of IP and user agent.
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://help.pinterest.com/en/business/article/eqs"
          rel="noopener noreferrer"
          target="_blank"
        >
          Pinterest Event Scoring Documentation
        </a>{" "}
        for more details on configuring recommended view-through properties to
        optimize for event quality.
      </p>
    ),
    configHelp: "Enter your conversion access token and ad account ID.",
    configFields: [
      {
        name: "Conversion Access Token",
        key: "conversionAccessToken",
        required: true,
        sensitive: true,
      },
      { name: "Ad Account ID", key: "adAccountId", required: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "pinterest-tag": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "pinterest-tag",
    name: "Pinterest Tag",
    key: "Pinterest Tag",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: PinterestIcon,
    configHelp:
      "Enter your Pinterest Tag ID, found on your account's Conversions page.",
    configFields: [{ name: "Tag ID", key: "tid", required: true }],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your Pinterest ad spend more efficient & optimized. The Freshpaint
        Pinterest Tag integration enables you to track conversions, and build
        and optimize audiences to reach valuable customers on Pinterest. Once
        configured, Freshpaint will send valuable event data to Pinterest so you
        can target based on actions users have token on your site, and gather
        valuable conversion insights.{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.pinterest.com/docs/tags/pinterest-tags/"
        >
          Pinterest Tag Documentation {">"}{" "}
        </a>
      </p>
    ),
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized. Pinterest recognizes{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.pinterest.com/docs/tags/pinterest-tags/"
        >
          certain standard events
        </a>{" "}
        that can be used to reate audiences and in conversion reporting. When
        you map an event to a standard Pinterest event, well automatically send
        the event to Pinterest. Additional events can still be sent to Pinterest
        as Custom Events to create audiences, but they may not be available in
        conversion mapping.
      </p>
    ),
    eventMappingConfigKey: "_pinterestEventMapping",
    eventMappingEventName: "Standard Pinterest Event",
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
    autocompleteMapping: [
      { name: "Checkout" },
      { name: "AddToCart" },
      { name: "PageVisit" },
      { name: "Signup" },
      { name: "WatchVideo" },
      { name: "Lead" },
      { name: "Search" },
      { name: "ViewCategory" },
      { name: "Custom" },
    ],
    getStandardMapping: getPinterestStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  podscribe: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "podscribe",
    name: "Podscribe",
    key: "Podscribe",
    type: "app",
    logoSquare: PodscribeIcon,
    configHelp: "Provide your Podscribe Advertiser ID.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserID", required: true },
    ],
    connectionMode: "server",
    /* TODO: Add docs for Podscribe */
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/podscribe",
    supportsBackfill: false,
    supportsCohorts: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    hasEventMapping: false,
    supportsServerSide: true,
    supportsTrack: true,
  }),
  qualaroo: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "qualaroo",
    name: "Qualaroo",
    key: "Qualaroo",
    type: "app",
    logoSquare: QualarooIcon,
    configHelp: "There is a URL in the JS that is 'ki.js/<id>/<token>.js'.",
    configFields: [
      { name: "ID", key: "customerId", required: true },
      {
        name: "Token",
        key: "siteToken",
        required: true,
      },
    ],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "quora-conversions-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "quora-conversions-api",
    name: "Quora Conversions API",
    key: "Quora Conversions API",
    type: "app",
    logoSquare: QuoraIcon,
    configHelp:
      "Provide your Quora Account ID and API Key. These can be found in the Quora Ads Manager.",
    configFields: [
      { name: "Account ID", key: "accountId", required: true },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Account ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  "reddit-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "reddit-ads",
    name: "Reddit Ads",
    key: "reddit-ads",
    type: "advertising",
    logoSquare: RedditIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The Reddit Ads integration in Freshpaint enables a HIPAA compliant
        method for Reddit campaign conversion events.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/reddit-ads"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: (
      <>
        Enter your Reddit Ads account ID. It is also referred to as the pixel
        ID. Your account ID may or may not contain the "t2_" prefix.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://business.reddithelp.com/s/article/conversion-access-token"
          rel="noopener noreferrer"
          target="_blank"
        >
          Reddit Documentation
        </a>{" "}
        for more details about generating a conversions access token.
      </>
    ),
    configFields: [
      { name: "Account ID", key: "accountId", required: true },
      {
        name: "Conversions access token",
        key: "conversionsAccessToken",
        required: true,
        sensitive: true,
      },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Account ID",
    defaultConsentManagementCategory: "marketing",
  }),
  "reddit-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "reddit-audiences",
    name: "Reddit Audiences",
    key: "Reddit Audiences",
    type: "app",
    logoSquare: RedditIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The Reddit Audiences integration enables syncing Freshpaint audiences to
        Reddit Custom Audiences for ad targeting.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://business.reddithelp.com/s/article/custom-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Reddit Custom Audiences Documentation
        </a>{" "}
        for more details.
      </p>
    ),
    configHelp: "Enter your Reddit Ads Account ID.",
    configFields: [
      { name: "Ad Account ID", key: "adAccountId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    customConfig: RedditAudiencesConfig,
    supportsMultiConfig: true,
    multiConfigLabel: "Ad Account ID",
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: true,
    supportsCohorts: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "replay-bird": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "replay-bird",
    name: "ReplayBird",
    key: "ReplayBird",
    type: "app",
    logoSquare: ReplayBirdIcon,
    configHelp:
      "Your API key is the long string of random letters and numbers in the JS script.",
    configFields: [{ name: "API Key", key: "siteKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  rollbar: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "rollbar",
    name: "Rollbar",
    key: "Rollbar",
    type: "app",
    logoSquare: RollbarIcon,
    configHelp: "Your token is at Settings > Project Access Tokens.",
    configFields: [
      { name: "Client Access Token", key: "accessToken", required: true },
    ],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "satis-meter": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "satis-meter",
    name: "SatisMeter",
    key: "SatisMeter",
    type: "app",
    logoSquare: SatisMeterIcon,
    configHelp: "Your key is in quotes after 'writeKey' in your JS script.",
    configFields: [{ name: "Write Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  sendinblue: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "sendinblue",
    name: "Sendinblue",
    key: "Sendinblue",
    type: "app",
    logoSquare: SendInBlueIcon,
    configHelp:
      "Your Client Key can be found in quotes after 'client_key' in the JS script at Automation > Settings > Tracking Code",
    configFields: [{ name: "Client Key", key: "clientKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsCohorts: true,
    connectionMode: "client",
  }),
  sentry: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "sentry",
    name: "Sentry",
    key: "Sentry",
    type: "app",
    logoSquare: SentryIcon,
    configHelp: "Your DSN can be found at the top of the projects page.",
    configFields: [{ name: "DSN", key: "config", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  simplifi: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "simplifi",
    name: "Simpli.fi Conversions API",
    key: "Simpli.fi",
    type: "app",
    logoSquare: SimplifiIcon,
    configHelp: (
      <>
        Configure conversion events using Transformations or Event Definition
        dynamic properties.
        <br />
        Each conversion event must have an{" "}
        <code className="inline text-xs">audience_key</code> property matching
        the relevant Simpli.fi conversion audience key.
        <br />
        <br />
        Please click the{" "}
        <span style={{ color: "blue", fontWeight: "bold" }}> SAVE </span> button
        below to configure this destination.
      </>
    ),
    configFields: [],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $sifi_transaction_id: "{{transactionID}}",
      $sifi_day: "{{sifiDay}}",
    },
    connectionMode: "server",
  }),
  siriusxm: new SaaSDestination({
    destinationCategories: ["Audio"],
    slug: "siriusxm",
    name: "SiriusXM",
    key: "SiriusXM",
    type: "app",
    logoSquare: SiriusXMIcon,
    configHelp: "Your App Name should be available in your SiriusXM dashboard.",
    configFields: [{ name: "App Name", key: "appName", required: true }],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    supportsMultiConfig: true,
    multiConfigLabel: "App Name",
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $siriusxm_aid: "[aid]",
      $siriusxm_oid: "[oid]",
      $siriusxm_cid: "[cid]",
    },
    connectionMode: "server",
  }),
  nextdoor: new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "nextdoor",
    name: "Nextdoor",
    key: "Nextdoor",
    type: "app",
    logoSquare: NextdoorIcon,
    configHelp:
      "Provide your Nextdoor Pixel ID and API Key. These can be found in the Nextdoor Ads Manager.",
    configFields: [
      { name: "Pixel ID", key: "pixelId", required: true },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  snapchat: new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "snapchat",
    name: "Snapchat",
    key: "Snapchat",
    type: "app",
    logoSquare: SnapchatIcon,
    configHelp:
      "Provide your Snap Ads Pixel ID and a static long-lived access token. These can be found in the Snap Ads Manager.",
    configFields: [
      { name: "Pixel ID", key: "pixelId", required: true },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  "snap-engage": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "snap-engage",
    name: "SnapEngage",
    key: "SnapEngage",
    type: "app",
    logoSquare: SnapEngageIcon,
    configHelp: "Your Widget ID is at the bottom of the 'Get the Code' tab.",
    configFields: [{ name: "Widget ID", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: false,
    connectionMode: "client",
  }),
  "spotify-conversions-api": new SaaSDestination({
    destinationCategories: ["Audio"],
    slug: "spotify-conversions-api",
    name: "Spotify Conversions API",
    key: "Spotify Conversions API",
    type: "app",
    logoSquare: SpotifyIcon,
    configHelp:
      "Provide your Spotify Conversions API Connection ID and a static long-lived access token. These can be found in the Spotify Ads Manager.",
    configFields: [
      { name: "Connection ID", key: "connectionID", required: true },
      {
        name: "Access Token",
        key: "accessToken",
        required: true,
        sensitive: true,
      },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Connection ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  stackadapt: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "stackadapt",
    name: "StackAdapt",
    key: "StackAdapt",
    type: "app",
    logoSquare: StackAdaptIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/stackadapt",
    configHelp: (
      <>
        Configure conversion events using Transformations or Event Definition
        dynamic properties.
        <br />
        Each conversion event must have a{" "}
        <code className="inline text-xs">conversion_id</code> property matching
        the relevant Conversion Event Unique ID.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/stackadapt"
          rel="noopener noreferrer"
          target="_blank"
        >
          StackAdapt Destination Documentation Page
        </a>{" "}
        for more details.
        <br />
        <br />
        Please click the{" "}
        <span style={{ color: "blue", fontWeight: "bold" }}> SAVE </span> button
        below to configure this destination.
      </>
    ),
    configFields: [],
    customConfig: StackAdaptCustomConfig,
    supportsServerSide: true,
    supportsBackfill: false,
    supportsTrack: true,
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $sapid: "{SA_POSTBACK_ID}",
    },
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "stackadapt-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "stackadapt-audiences",
    name: "StackAdapt Audiences",
    key: "StackAdapt Audiences",
    type: "advertising",
    logoSquare: StackAdaptIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsTrack: false,
    configHelp: "",
    configFields: [
      {
        name: "Advertiser ID",
        key: "advertiserId",
        required: true,
        description: (
          <>
            Provide the ID of the StackAdapt advertiser this integration is for.
            To find this ID, log into your StackAdapt account, open the{" "}
            <a
              className="hover underline"
              href="https://stackadapt.com/overview/advertisers"
              target="_blank"
              rel="nofollow noreferrer noopener"
            >
              advertisers page
            </a>
            , and click the advertiser you want to use. The URL for the
            advertiser detail page will look like this:{" "}
            <code>stackadapt.com/sub_advertiser/edit?id=12345&</code>. Copy the
            numeric ID following the query param <code>?id=</code> (without the{" "}
            <code>&amp;</code> character) and use it to configure this
            integration in Freshpaint.
          </>
        ),
      },
      {
        name: "GraphQL Token",
        key: "graphQLAPIToken",
        required: true,
        description: (
          <>
            Enter your StackAdapt GraphQL API token. Reach out to your
            StackAdapt account managers or account executives to get this token
            if you do not have one already.
          </>
        ),
      },
    ],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/audiences/audience-integrations/stackadapt-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    connectionMode: "server",
    customConfig: StackAdaptAudiences,
    docsURL:
      "https://documentation.freshpaint.io/audiences/audience-integrations/stackadapt-audiences",
    defaultConsentManagementCategory: "marketing",
  }),
  stonly: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "stonly",
    name: "Stonly",
    key: "Stonly",
    type: "app",
    logoSquare: StonlyIcon,
    configHelp:
      "You can find your API Key by going to Team Management > Integrations.",
    configFields: [
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  taplytics: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "taplytics",
    name: "Taplytics",
    key: "Taplytics",
    type: "app",
    logoSquare: TaplyticsIcon,
    configHelp: "Find your JS SDK Key in the settings page.",
    configFields: [{ name: "JS SDK Key", key: "apiKey", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  tapstream: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "tapstream",
    name: "Tapstream",
    key: "Tapstream",
    type: "app",
    logoSquare: TapstreamIcon,
    configHelp: "Find your Account Name by clicking the dot in the toolbar.",
    configFields: [
      { name: "Account Name", key: "accountName", required: true },
    ],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  thetradedesk: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "thetradedesk",
    name: "theTradeDesk",
    key: "theTradeDesk",
    type: "advertising",
    logoSquare: TheTradeDeskIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/thetradedesk",
    configHelp: (
      <>
        You can find your Advertiser ID in the URL by going to Inventory -&gt;
        Site/App in theTradeDesk UI.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/thetradedesk/thetradedesk-quick-start-guide"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/thetradedesk"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      {
        name: "Advertiser ID",
        key: "advertiserId",
        sensitive: false,
        required: true,
      },
    ],
    supportsServerSide: true,
    supportsBackfill: false,
    supportsTrack: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $ttdimp: "%%TTD_IMPRESSIONID%%",
    },
    impressionPixelParamsCM360: {
      $ttdimp: "ttdimp",
    },
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "tiktok-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "tiktok-ads",
    name: "TikTok Ads",
    key: "TikTok Ads",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: TiktokIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/tiktok-ads",
    configHelp: (
      <>
        Find your Pixel ID in the TikTok Ads Manager. You can generate your
        Access Token there as well.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://ads.tiktok.com/gateway/docs/index?identify_key=2b9b4278e47b275f36e7c39a4af4ba067d088e031d5f5fe45d381559ac89ba48&doc_id=1701890979375106"
          rel="noopener noreferrer"
          target="_blank"
        >
          TikTok Events API Documentation
        </a>{" "}
        for more details.
      </>
    ),
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        TikTok Ads is used to send data to TikTok.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/tiktok-ads"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      {
        name: "Access Token",
        key: "accessToken",
        sensitive: true,
        required: true,
      },
      {
        name: "Pixel ID",
        key: "pixelId",
        sensitive: false,
        required: true,
      },
    ],
    eventMappingEventName: "TikTok Standard Event",
    eventMappingConfigKey: "_standardEvents",
    eventMappingSubheader: "Map your events to Standard TikTok Events",
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized. TikTok recognizes{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://ads.tiktok.com/marketing_api/docs?id=1741601162187777"
        >
          certain standard events
        </a>{" "}
        that can be used across custom audiences, custom conversions, conversion
        tracking, and conversion optimization within TikTok. When you map an
        event to a standard TikTok event, we will automatically send the event
        by that name to TikTok.
      </p>
    ),
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    autocompleteMapping: [
      { name: "AddPaymentInfo" },
      { name: "AddToCart" },
      { name: "AddToWishlist" },
      { name: "ClickButton" },
      { name: "CompletePayment" },
      { name: "CompleteRegistration" },
      { name: "Contact" },
      { name: "Download" },
      { name: "InitiateCheckout" },
      { name: "PlaceAnOrder" },
      { name: "Search" },
      { name: "SubmitForm" },
      { name: "Subscribe" },
      { name: "ViewContent" },
    ],
    getStandardMapping: getTikTokStandardMapping,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    defaultConsentManagementCategory: "marketing",
  }),
  "tiktok-insights": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "tiktok-insights",
    name: "TikTok Insights",
    key: "TikTok Insights",
    type: "advertising",
    logoSquare: TiktokIcon,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsTrack: false,
    supportsCohorts: false,
    configHelp:
      "Add your Advertiser ID to connect your TikTok Insights account to Freshpaint.",
    configBodyHelp: (
      <p className="text-sm">
        The TikTok Insights destination allows Freshpaint to access your TikTok
        Insights campaign information and use it to enable the Insights Product.
        <br />
        <br />
        This destination is not able to process events and cannot be used to
        send events to TikTok Ads. If you&apos;re looking to send events to
        TikTok Ads, please use the TikTok Ads destination instead.
      </p>
    ),
    configFields: [
      {
        name: "Advertiser ID",
        key: "advertiserID",
        required: true,
        sensitive: false,
      },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    connectionMode: "server",
    customConfig: TikTokOAuthCustomConfig,
    defaultConsentManagementCategory: "marketing",
  }),
  "twitter-ads": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "twitter-ads",
    name: "Twitter Ads",
    key: "Twitter Ads",
    type: "advertising",
    hasEventMapping: true,
    logoSquare: TwitterIcon,
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/twitter-ads",
    configHelp: (
      <p className="text-textSubtle text-xs">
        The Twitter Pixel ID lets Freshpaint connect to your Twitter Ads
        account. See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/twitter-ads"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [{ name: "Pixel ID", key: "page", required: true }],
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Integrate Twitter Ads with Freshpaint to send key event data to Twitter.
        Some key use cases include targeting users similar to your top
        customers, and retargeting shopping cart abandoners on Twitter.
      </p>
    ),
    eventMappingBodyHelp: (
      <p className="text-textSubtle text-xs">
        Make your ad spend more efficient & optimized by sending conversion
        events to Twitter. Freshpaint enables you to map events in Freshpaint to
        a corresponding Twitter Event ID (looks like tw-xxxxx-xxxxx). See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/twitter-ads"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    eventMappingEventName: "Twitter Event ID (tw-xxxxx-xxxxx)",
    eventMappingConfigKey: "_events",
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
    connectionMode: "client",
    getStandardMapping: getTwitterStandardMapping,
    defaultConsentManagementCategory: "marketing",
  }),
  userpilot: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "userpilot",
    name: "Userpilot",
    key: "Userpilot",
    type: "app",
    logoSquare: UserpilotIcon,
    configHelp: (
      <>
        You can retrieve your App Token from your{" "}
        <a href="https://run.userpilot.io/settings/installation">
          Userpilot dashboard
        </a>
        .
      </>
    ),
    configFields: [
      { name: "App Token", key: "appToken", required: true, sensitive: true },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  variance: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "variance",
    name: "Variance",
    key: "Variance",
    type: "app",
    logoSquare: VarianceIcon,
    configHelp:
      "Find your credentials by going to Settings > Integrations and configuring a Freshpaint integration.",
    configFields: [
      {
        name: "Webhook URL",
        key: "webhookURL",
        required: true,
        sensitive: true,
      },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  vero: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "vero",
    name: "Vero Cloud",
    key: "Vero",
    type: "app",
    logoSquare: VeroIcon,
    configHelp: "Your API Keys can be found in your Vero Cloud settings.",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/vero",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Vero Cloud is a data-driven email marketing tool.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/vero"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configFields: [
      { name: "API Key", key: "apiKey", required: true },
      { name: "Auth Token", key: "authToken", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "client",
  }),
  viant: new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "viant",
    name: "Viant",
    key: "viant",
    type: "advertising",
    logoSquare: ViantIcon,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Viant's DSP is a demand side platform that enables you to reach your
        target customers with DSP ads seamlessly across all programmatic
        channels and formats.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/advertising-destinations/viant"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: "Enter your Viant Advertiser ID.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserId", required: true },
    ],
    supportsImpressionPixel: true,
    impressionPixelParams: {
      // eslint-disable-next-line no-template-curly-in-string
      $viant_impid: "${ADELPHIC_CLICKID}",
    },
    supportsBackfill: false,
    supportsTrack: true,
    supportsServerSide: true,
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    defaultConsentManagementCategory: "marketing",
  }),
  "thetradedesk-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "thetradedesk-audiences",
    name: "theTradeDesk Audiences",
    key: "theTradeDesk Audiences",
    type: "advertising",
    logoSquare: TheTradeDeskIcon,
    hasEventMapping: false,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        The theTradeDesk Audiences integration enables syncing Freshpaint
        audiences to theTradeDesk for ad targeting.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/audiences/audience-integrations/thetradedesk-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: "Enter your theTradeDesk Advertiser ID and API token.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserId", required: true },
      { name: "API Token", key: "apiToken", required: true },
    ],
    customConfig: TheTradeDeskAudiences,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: true,
    connectionMode: "server",
    defaultConsentManagementCategory: "marketing",
  }),
  "viant-audiences": new SaaSDestination({
    destinationCategories: ["Audiences"],
    slug: "viant-audiences",
    name: "Viant Audiences",
    key: "Viant Audiences",
    type: "advertising",
    logoSquare: ViantIcon,
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/audiences/audience-integrations/viant-audiences"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: "Enter your Viant Account and Advertiser IDs.",
    configFields: [
      { name: "Account ID", key: "accountId", required: true },
      { name: "Advertiser ID", key: "advertiserId", required: true },
      { name: "OAuth Token", key: "oauthToken", required: true },
    ],
    customConfig: ViantAudiencesConfig,
    supportsBackfill: false,
    supportsTrack: false,
    supportsServerSide: true,
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    defaultConsentManagementCategory: "marketing",
  }),
  vibe: new SaaSDestination({
    destinationCategories: ["Direct response ads", "CTV"],
    slug: "vibe",
    name: "Vibe Conversions API",
    key: "Vibe Conversions API",
    type: "app",
    logoSquare: VibeIcon,
    configHelp:
      "Provide your Vibe Pixel ID (AID). This can be found in your Vibe account settings.",
    configFields: [{ name: "Pixel ID", key: "aid", required: true }],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
    supportsMultiConfig: true,
    multiConfigLabel: "Pixel ID",
  }),
  "web-engage": new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "web-engage",
    name: "WebEngage",
    key: "WebEngage",
    type: "app",
    logoSquare: WebEngageIcon,
    configHelp: "Your token is the value in quotes at the end of the script.",
    configFields: [{ name: "Token", key: "licenseCode", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  webhooks: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "webhooks",
    name: "Webhooks",
    key: "Webhooks",
    type: "app",
    logoSquare: WebhookIcon,
    configHelp: "Configure your webhook endpoints and headers",
    configFields: [
      {
        name: "Webhooks",
        key: "webhooks",
        required: true,
        type: "list",
        defaultValue: [],
      },
      {
        name: "Enable Identify Events",
        key: "enableIdentifyEvents",
        required: false,
        type: "boolean",
        defaultValue: false,
        description: (
          <>
            Freshpaint will send&nbsp;
            <a
              className="underline"
              style={{ color: "blue" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://documentation.freshpaint.io/developer/freshpaint-sdk-reference#identify"
            >
              identify events
            </a>
            &nbsp;containing information about who your users are to your
            webhook(s).
          </>
        ),
      },
      {
        name: "Enable Pageview Events",
        key: "enablePageviewEvents",
        required: false,
        type: "boolean",
        defaultValue: false,
        description: (
          <>
            Freshpaint will send a pageview event to your webhook(s) each time
            the javascript SDK is loaded on a webpage. This option does not
            affect pageview events defined on the Event Schema page.
          </>
        ),
      },
    ],
    hasEventMapping: false,
    customConfig: WebhooksCustomConfig,
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: true,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  woopra: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "woopra",
    name: "Woopra",
    key: "Woopra",
    type: "app",
    logoSquare: WoopraIcon,
    configHelp: "Enter your domain.",
    configFields: [{ name: "Domain", key: "domain", required: true }],
    supportsBackfill: false,
    supportsTrack: true,
    connectionMode: "client",
  }),
  "yelp-conversions-api": new SaaSDestination({
    destinationCategories: ["Direct response ads"],
    slug: "yelp-conversions-api",
    name: "Yelp Conversions API",
    key: "Yelp Conversions API",
    type: "app",
    logoSquare: YelpIcon,
    configHelp:
      "Provide your Yelp API Key and optional Client ID from your Yelp Ads Manager.",
    configFields: [
      { name: "Yelp API Key", key: "apiKey", required: true, sensitive: true },
      {
        name: "Yelp Client ID",
        key: "clientID",
        required: false,
        sensitive: false,
      },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Yelp Client ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  zendesk: new SaaSDestination({
    destinationCategories: ["Data activation"],
    slug: "zendesk",
    name: "Zendesk",
    key: "Zendesk",
    type: "app",
    logoSquare: ZendeskIcon,
    configName: "Credentials",
    docsURL:
      "https://documentation.freshpaint.io/integrations/destinations/apps/zendesk",
    configBodyHelp: (
      <p className="text-textSubtle text-xs">
        Sync user data to your Zendesk customer support system.
        <br />
        <br />
        See the{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          href="https://documentation.freshpaint.io/integrations/destinations/apps/zendesk"
          rel="noopener noreferrer"
          target="_blank"
        >
          Freshpaint Documentation
        </a>{" "}
        for more details and assistance on setup.
      </p>
    ),
    configHelp: (
      <>
        Enter your Zendesk subdomain and your email address used to log in to
        Zendesk. Follow Zendesk&apos;s instructions to{" "}
        <a
          className="underline"
          style={{ color: "blue" }}
          target="_blank"
          rel="noopener noreferrer"
          href="https://support.zendesk.com/hc/en-us/articles/4408889192858-Generating-a-new-API-token"
        >
          generate an API token
        </a>{" "}
        and paste the value here.
      </>
    ),
    configFields: [
      { name: "Subdomain", key: "subdomain", required: true },
      { name: "Email", key: "email", required: true },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsServerSide: true,
    supportsTrack: false,
    supportsCohorts: true,
    connectionMode: "server",
  }),
  "zeta-conversions-api": new SaaSDestination({
    destinationCategories: ["Demand side platform", "CTV"],
    slug: "zeta-conversions-api",
    name: "Zeta Conversions API",
    key: "Zeta Conversions API",
    type: "app",
    logoSquare: ZetaIcon,
    configHelp:
      "Provide your Zeta Advertiser ID, Pixel ID, Site ID, and API Key. These can be found in your Zeta DSP account.",
    configFields: [
      { name: "Advertiser ID", key: "advertiserID", required: true },
      { name: "Pixel ID", key: "pixelID", required: true },
      { name: "Site ID", key: "siteID", required: true },
      { name: "API Key", key: "apiKey", required: true, sensitive: true },
    ],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Advertiser ID",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
    supportsImpressionPixel: true,
    impressionPixelParams: {
      $zeta_impid: "{adinstanceid}",
      $zeta_userid: "{userid}",
    },
  }),

  // Requestable destinations:
  bronto: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "bronto",
    name: "Bronto",
    logoSquare: BrontoIcon,
    type: "app",
    key: "Bronto",
  }),
  emarsys: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "emarsys",
    name: "Emarsys",
    logoSquare: EmarsysIcon,
    type: "app",
    key: "Emarsys",
  }),
  extole: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "extole",
    name: "Extole",
    logoSquare: ExtoleIcon,
    type: "app",
    key: "Extole",
  }),
  freshmarketer: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "freshmarketer",
    name: "Freshmarketer",
    logoSquare: FreshmarketerIcon,
    type: "app",
    key: "Freshmarketer",
  }),
  exponea: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "exponea",
    name: "Exponea",
    logoSquare: ExponeaIcon,
    type: "app",
    key: "Exponea",
  }),
  trustpilot: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "trustpilot",
    name: "Trustpilot",
    logoSquare: TrustpilotIcon,
    type: "app",
    key: "Trustpilot",
  }),
  "2mee": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "2mee",
    name: "2mee",
    logoSquare: TwoMeeIcon,
    type: "app",
    key: "2mee",
  }),
  "ab-smartly": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "ab-smartly",
    name: "AB Smartly",
    logoSquare: AbSmartlyIcon,
    type: "app",
    key: "AB Smartly",
  }),
  adikteev: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "adikteev",
    name: "Adikteev",
    logoSquare: AdikteevIcon,
    type: "advertising",
    key: "Adikteev",
  }),
  "adlearn-open-platform": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "adlearn-open-platform",
    name: "AdLearn Open Platform",
    logoSquare: AdLearnOpenPlatformIcon,
    type: "app",
    key: "AdLearn Open Platform",
  }),
  adquick: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "adquick",
    name: "AdQuick",
    logoSquare: AdQuickIcon,
    type: "advertising",
    key: "AdQuick",
  }),
  adtriba: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "adtriba",
    name: "Adtriba",
    logoSquare: AdtribaIcon,
    type: "advertising",
    key: "Adtriba",
  }),
  airship: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "airship",
    name: "Airship",
    logoSquare: AirshipIcon,
    type: "app",
    key: "Airship",
  }),
  alexa: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "alexa",
    name: "Alexa",
    logoSquare: AlexaIcon,
    type: "app",
    key: "Alexa",
  }),
  "algolia-insights": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "algolia-insights",
    name: "Algolia Insights",
    logoSquare: AlgoliaInsightsIcon,
    type: "app",
    key: "Algolia Insights",
  }),
  "amazon-eventbridge": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "amazon-eventbridge",
    name: "Amazon EventBridge",
    logoSquare: AwsIcon,
    type: "app",
    key: "Amazon EventBridge",
  }),
  "amazon-kinesis": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "amazon-kinesis",
    name: "Amazon Kinesis",
    logoSquare: AwsKinesisIcon,
    type: "app",
    key: "Amazon Kinesis",
  }),
  "amazon-kinesis-firehose": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "amazon-kinesis-firehose",
    name: "Amazon Kinesis Firehose",
    logoSquare: AwsKinesisIcon,
    type: "app",
    key: "Amazon Kinesis Firehose",
  }),
  "amazon-lambda": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "amazon-lambda",
    name: "Amazon Lambda",
    logoSquare: AwsLambdaIcon,
    type: "app",
    key: "Amazon Lambda",
  }),
  "amazon-personalize": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "amazon-personalize",
    name: "Amazon Personalize",
    logoSquare: AwsIcon,
    type: "app",
    key: "Amazon Personalize",
  }),
  ambassador: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "ambassador",
    name: "Ambassador",
    logoSquare: AmbassadorIcon,
    type: "app",
    key: "Ambassador",
  }),
  anodot: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "anodot",
    name: "Anodot",
    logoSquare: AnodotIcon,
    type: "app",
    key: "Anodot",
  }),
  appnexus: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "appnexus",
    name: "AppNexus",
    logoSquare: AppNexusIcon,
    type: "advertising",
    key: "AppNexus",
  }),
  applovin: new SaaSDestination({
    destinationCategories: ["Demand side platform"],
    slug: "applovin",
    name: "AppLovin",
    key: "AppLovin",
    type: "app",
    logoSquare: AppLovinIcon,
    configHelp:
      "Provide your AppLovin Event Key. This can be found in the AppLovin Ads Manager.",
    // No API Key field here. They use a global key from secretsmanager.
    configFields: [{ name: "Event Key", key: "eventKey", required: true }],
    supportsBackfill: false,
    supportsMultiConfig: true,
    multiConfigLabel: "Event Key",
    supportsServerSide: true,
    supportsTrack: true,
    connectionMode: "server",
  }),
  apptimize: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "apptimize",
    name: "Apptimize",
    logoSquare: ApptimizeIcon,
    type: "app",
    key: "Apptimize",
  }),
  apteligent: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "apteligent",
    name: "Apteligent",
    logoSquare: ApteligentIcon,
    type: "app",
    key: "Apteligent",
  }),
  asayer: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "asayer",
    name: "Asayer",
    logoSquare: AsayerIcon,
    type: "app",
    key: "Asayer",
  }),
  atatus: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "atatus",
    name: "Atatus",
    logoSquare: AtatusIcon,
    type: "app",
    key: "Atatus",
  }),
  attribution: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "attribution",
    name: "Attribution",
    logoSquare: AttributionIcon,
    type: "app",
    key: "Attribution",
  }),
  auryc: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "auryc",
    name: "Auryc",
    logoSquare: AurycIcon,
    type: "app",
    key: "Auryc",
  }),
  batch: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "batch",
    name: "Batch",
    logoSquare: BatchIcon,
    type: "app",
    key: "Batch",
  }),
  beamer: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "beamer",
    name: "Beamer",
    logoSquare: BeamerIcon,
    type: "app",
    key: "Beamer",
  }),
  "bime-analytics": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "bime-analytics",
    name: "BIME Analytics",
    logoSquare: BimeAnalyticsIcon,
    type: "app",
    key: "BIME Analytics",
  }),
  blendo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "blendo",
    name: "Blendo",
    logoSquare: BlendoIcon,
    type: "app",
    key: "Blendo",
  }),
  blueshift: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "blueshift",
    name: "Blueshift",
    logoSquare: BlueshiftIcon,
    type: "advertising",
    key: "Blueshift",
  }),
  "branch-metrics": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "branch-metrics",
    name: "Branch Metrics",
    logoSquare: BranchMetricsIcon,
    type: "app",
    key: "Branch Metrics",
  }),
  bucket: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "bucket",
    name: "Bucket",
    logoSquare: BucketIcon,
    type: "app",
    key: "Bucket",
  }),
  bugherd: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "bugherd",
    name: "BugHerd",
    logoSquare: BugHerdIcon,
    type: "app",
    key: "BugHerd",
  }),
  button: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "button",
    name: "Button",
    logoSquare: ButtonIcon,
    type: "app",
    key: "Button",
  }),
  buzzboard: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "buzzboard",
    name: "BuzzBoard",
    logoSquare: BuzzBoardIcon,
    type: "app",
    key: "BuzzBoard",
  }),
  bytegain: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "bytegain",
    name: "ByteGain",
    logoSquare: ByteGainIcon,
    type: "advertising",
    key: "ByteGain",
  }),
  calixa: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "calixa",
    name: "Calixa",
    logoSquare: CalixaIcon,
    type: "app",
    key: "Calixa",
  }),
  callingly: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "callingly",
    name: "Callingly",
    logoSquare: CallinglyIcon,
    type: "app",
    key: "Callingly",
  }),
  calq: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "calq",
    name: "Calq",
    logoSquare: CalqIcon,
    type: "app",
    key: "Calq",
  }),
  candu: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "candu",
    name: "Candu",
    logoSquare: CanduIcon,
    type: "app",
    key: "Candu",
  }),
  canny: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "canny",
    name: "Canny",
    logoSquare: CannyIcon,
    type: "app",
    key: "Canny",
  }),
  chartbeat: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "chartbeat",
    name: "Chartbeat",
    logoSquare: ChartbeatIcon,
    type: "app",
    key: "Chartbeat",
  }),
  chartio: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "chartio",
    name: "Chartio",
    logoSquare: ChartioIcon,
    type: "app",
    key: "Chartio",
  }),
  churnzero: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "churnzero",
    name: "ChurnZero",
    logoSquare: ChurnZeroIcon,
    type: "app",
    key: "ChurnZero",
  }),
  clearbrain: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "clearbrain",
    name: "ClearBrain",
    logoSquare: ClearBrainIcon,
    type: "app",
    key: "ClearBrain",
  }),
  clicky: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "clicky",
    name: "Clicky",
    logoSquare: ClickyIcon,
    type: "app",
    key: "Clicky",
  }),
  clientsuccess: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "clientsuccess",
    name: "ClientSuccess",
    logoSquare: ClientSuccessIcon,
    type: "app",
    key: "ClientSuccess",
  }),
  cliff: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "cliff",
    name: "Cliff",
    logoSquare: CliffIcon,
    type: "app",
    key: "Cliff",
  }),
  comscore: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "comscore",
    name: "comScore",
    logoSquare: ComScoreIcon,
    type: "app",
    key: "comScore",
  }),
  convertflow: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "convertflow",
    name: "ConvertFlow",
    logoSquare: ConvertFlowIcon,
    type: "app",
    key: "ConvertFlow",
  }),
  convertro: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "convertro",
    name: "Convertro",
    logoSquare: ConvertroIcon,
    type: "app",
    key: "Convertro",
  }),
  countly: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "countly",
    name: "Countly",
    logoSquare: CountlyIcon,
    type: "app",
    key: "Countly",
  }),
  courier: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "courier",
    name: "Courier",
    logoSquare: CourierIcon,
    type: "app",
    key: "Courier",
  }),
  criteo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "criteo",
    name: "Criteo",
    logoSquare: CriteoIcon,
    type: "advertising",
    key: "Criteo",
  }),
  crowdpower: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "crowdpower",
    name: "CrowdPower",
    logoSquare: CrowdPowerIcon,
    type: "app",
    key: "CrowdPower",
  }),
  cruncher: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "cruncher",
    name: "Cruncher",
    logoSquare: CruncherIcon,
    type: "app",
    key: "Cruncher",
  }),
  custify: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "custify",
    name: "Custify",
    logoSquare: CustifyIcon,
    type: "app",
    key: "Custify",
  }),
  customersuccessbox: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "customersuccessbox",
    name: "CustomerSuccessBox",
    logoSquare: CustomerSuccessBoxIcon,
    type: "app",
    key: "CustomerSuccessBox",
  }),
  "customfit-ai": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "customfit-ai",
    name: "CustomFit.ai",
    logoSquare: CustomFitaiIcon,
    type: "app",
    key: "CustomFit.ai",
  }),
  "data-lakes": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "data-lakes",
    name: "Data Lakes",
    logoSquare: DataLakesIcon,
    type: "app",
    key: "Data Lakes",
  }),
  delighted: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "delighted",
    name: "Delighted",
    logoSquare: DelightedIcon,
    type: "app",
    key: "Delighted",
  }),
  digioh: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "digioh",
    name: "Digioh",
    logoSquare: DigiohIcon,
    type: "app",
    key: "Digioh",
  }),
  "dreamdata-io": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "dreamdata-io",
    name: "Dreamdata IO",
    logoSquare: DreamdataIoIcon,
    type: "app",
    key: "Dreamdata IO",
  }),
  "email-aptitude": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "email-aptitude",
    name: "Email Aptitude",
    logoSquare: EmailAptitudeIcon,
    type: "app",
    key: "Email Aptitude",
  }),
  emma: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "emma",
    name: "EMMA",
    logoSquare: EmmaIcon,
    type: "app",
    key: "EMMA",
  }),
  enjoyhq: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "enjoyhq",
    name: "EnjoyHQ",
    logoSquare: EnjoyHqIcon,
    type: "app",
    key: "EnjoyHQ",
  }),
  epica: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "epica",
    name: "EPICA",
    logoSquare: EpicaIcon,
    type: "app",
    key: "EPICA",
  }),
  everflow: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "everflow",
    name: "Everflow",
    logoSquare: EverflowIcon,
    type: "advertising",
    key: "Everflow",
  }),
  "experiments-by-growthhackers": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "experiments-by-growthhackers",
    name: "Experiments by Growthhackers",
    logoSquare: ExperimentsbyGrowthhackersIcon,
    type: "app",
    key: "Experiments by Growthhackers",
  }),
  factorsai: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "factorsai",
    name: "FactorsAI",
    logoSquare: FactorsAiIcon,
    type: "app",
    key: "FactorsAI",
  }),
  firebase: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "firebase",
    name: "Firebase",
    logoSquare: FirebaseIcon,
    type: "advertising",
    key: "Firebase",
  }),
  flurry: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "flurry",
    name: "Flurry",
    logoSquare: FlurryIcon,
    type: "advertising",
    key: "Flurry",
  }),
  foxmetrics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "foxmetrics",
    name: "FoxMetrics",
    logoSquare: FoxMetricsIcon,
    type: "app",
    key: "FoxMetrics",
  }),
  friendbuy: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "friendbuy",
    name: "Friendbuy",
    logoSquare: FriendbuyIcon,
    type: "app",
    key: "Friendbuy",
  }),
  funnelenvy: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "funnelenvy",
    name: "FunnelEnvy",
    logoSquare: FunnelEnvyIcon,
    type: "app",
    key: "FunnelEnvy",
  }),
  funnelfox: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "funnelfox",
    name: "FunnelFox",
    logoSquare: FunnelFoxIcon,
    type: "app",
    key: "FunnelFox",
  }),
  "gainsight-px": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "gainsight-px",
    name: "Gainsight PX",
    logoSquare: GainsightPxIcon,
    type: "app",
    key: "Gainsight PX",
  }),
  gameball: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "gameball",
    name: "Gameball",
    logoSquare: GameballIcon,
    type: "app",
    key: "Gameball",
  }),
  gist: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "gist",
    name: "Gist",
    logoSquare: GistIcon,
    type: "app",
    key: "Gist",
  }),
  goedle: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "goedle",
    name: "Goedle",
    logoSquare: GoedleIcon,
    type: "app",
    key: "Goedle",
  }),
  "google-cloud-function": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "google-cloud-function",
    name: "Google Cloud Function",
    logoSquare: GoogleCloudFunctionIcon,
    type: "app",
    key: "Google Cloud Function",
  }),
  "google-cloud-storage": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "google-cloud-storage",
    name: "Google Cloud Storage",
    logoSquare: GoogleCloudStorageIcon,
    type: "app",
    key: "Google Cloud Storage",
  }),
  "google-display-360": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "google-display-360",
    name: "Google Display 360",
    logoSquare: GoogleDisplay360Icon,
    type: "advertising",
    key: "Google Display 360",
  }),
  hasoffers: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "hasoffers",
    name: "HasOffers",
    logoSquare: HasOffersIcon,
    type: "advertising",
    key: "HasOffers",
  }),
  hawkei: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "hawkei",
    name: "Hawkei",
    logoSquare: HawkeiIcon,
    type: "app",
    key: "Hawkei",
  }),
  "headsup-ai": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "headsup-ai",
    name: "HeadsUp AI",
    logoSquare: HeadsUpAiIcon,
    type: "app",
    key: "HeadsUp AI",
  }),
  "help-scout": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "help-scout",
    name: "Help Scout",
    logoSquare: HelpScoutIcon,
    type: "app",
    key: "Help Scout",
  }),
  hittail: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "hittail",
    name: "HitTail",
    logoSquare: HitTailIcon,
    type: "app",
    key: "HitTail",
  }),
  hull: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "hull",
    name: "Hull",
    logoSquare: HullIcon,
    type: "app",
    key: "Hull",
  }),
  hydra: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "hydra",
    name: "Hydra",
    logoSquare: HydraIcon,
    type: "app",
    key: "Hydra",
  }),
  "ibm-universal-behavior-exchange": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "ibm-universal-behavior-exchange",
    name: "IBM Universal Behavior Exchange",
    logoSquare: IbmUniversalBehaviorExchangeIcon,
    type: "app",
    key: "IBM Universal Behavior Exchange",
  }),
  improvely: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "improvely",
    name: "Improvely",
    logoSquare: ImprovelyIcon,
    type: "app",
    key: "Improvely",
  }),
  indicative: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "indicative",
    name: "Indicative",
    logoSquare: IndicativeIcon,
    type: "app",
    key: "Indicative",
  }),
  inkit: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "inkit",
    name: "Inkit",
    logoSquare: InkitIcon,
    type: "advertising",
    key: "Inkit",
  }),
  insider: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "insider",
    name: "Insider",
    logoSquare: InsiderIcon,
    type: "app",
    key: "Insider",
  }),
  interana: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "interana",
    name: "Interana",
    logoSquare: InteranaIcon,
    type: "app",
    key: "Interana",
  }),
  "iron-io": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "iron-io",
    name: "Iron.io",
    logoSquare: IronIoIcon,
    type: "app",
    key: "Iron.io",
  }),
  jackdb: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "jackdb",
    name: "JackDB",
    logoSquare: JackDbIcon,
    type: "app",
    key: "JackDB",
  }),
  "journy-io": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "journy-io",
    name: "journy io",
    logoSquare: JournyioIcon,
    type: "app",
    key: "journy io",
  }),
  kahuna: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "kahuna",
    name: "Kahuna",
    logoSquare: KahunaIcon,
    type: "app",
    key: "Kahuna",
  }),
  kameleoon: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "kameleoon",
    name: "Kameleoon",
    logoSquare: KameleoonIcon,
    type: "app",
    key: "Kameleoon",
  }),
  kevel: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "kevel",
    name: "Kevel",
    logoSquare: KevelIcon,
    type: "advertising",
    key: "Kevel",
  }),
  kubit: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "kubit",
    name: "Kubit",
    logoSquare: KubitIcon,
    type: "app",
    key: "Kubit",
  }),
  lantern: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "lantern",
    name: "Lantern",
    logoSquare: LanternIcon,
    type: "app",
    key: "Lantern",
  }),
  "launchdarkly-events": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "launchdarkly-events",
    name: "LaunchDarkly Events",
    logoSquare: LaunchDarklyEventsIcon,
    type: "app",
    key: "LaunchDarkly Events",
  }),
  leanplum: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "leanplum",
    name: "Leanplum",
    logoSquare: LeanplumIcon,
    type: "app",
    key: "Leanplum",
  }),
  learndot: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "learndot",
    name: "Learndot",
    logoSquare: LearndotIcon,
    type: "app",
    key: "Learndot",
  }),
  librato: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "librato",
    name: "Librato",
    logoSquare: LibratoIcon,
    type: "app",
    key: "Librato",
  }),
  localytics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "localytics",
    name: "Localytics",
    logoSquare: LocalyticsIcon,
    type: "app",
    key: "Localytics",
  }),
  lou: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "lou",
    name: "Lou",
    logoSquare: LouIcon,
    type: "app",
    key: "Lou",
  }),
  lytics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "lytics",
    name: "Lytics",
    logoSquare: LyticsIcon,
    type: "app",
    key: "Lytics",
  }),
  mabl: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mabl",
    name: "mabl",
    logoSquare: MablIcon,
    type: "app",
    key: "mabl",
  }),
  madkudu: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "madkudu",
    name: "MadKudu",
    logoSquare: MadKuduIcon,
    type: "app",
    key: "MadKudu",
  }),
  mailchimp: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mailchimp",
    name: "Mailchimp",
    logoSquare: MailchimpIcon,
    type: "app",
    key: "Mailchimp",
  }),
  mailjet: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mailjet",
    name: "Mailjet",
    logoSquare: MailjetIcon,
    type: "app",
    key: "Mailjet",
  }),
  mammoth: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mammoth",
    name: "Mammoth",
    logoSquare: MammothIcon,
    type: "app",
    key: "Mammoth",
  }),
  marketo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "marketo",
    name: "Marketo",
    logoSquare: MarketoIcon,
    type: "app",
    key: "Marketo",
  }),
  markettailor: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "markettailor",
    name: "Markettailor",
    logoSquare: MarkettailorIcon,
    type: "app",
    key: "Markettailor",
  }),
  matomo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "matomo",
    name: "Matomo",
    logoSquare: MatomoIcon,
    type: "app",
    key: "Matomo",
  }),
  mediamath: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mediamath",
    name: "MediaMath",
    logoSquare: MediaMathIcon,
    type: "advertising",
    key: "MediaMath",
  }),
  metacx: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "metacx",
    name: "MetaCX",
    logoSquare: MetaCxIcon,
    type: "app",
    key: "MetaCX",
  }),
  "millennial-media": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "millennial-media",
    name: "Millennial Media",
    logoSquare: MillennialMediaIcon,
    type: "advertising",
    key: "Millennial Media",
  }),
  mode: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mode",
    name: "Mode",
    logoSquare: ModeIcon,
    type: "app",
    key: "Mode",
  }),
  "modern-pricing": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "modern-pricing",
    name: "Modern Pricing",
    logoSquare: ModernPricingIcon,
    type: "app",
    key: "Modern Pricing",
  }),
  moengage: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "moengage",
    name: "MoEngage",
    logoSquare: MoEngageIcon,
    type: "app",
    key: "MoEngage",
  }),
  "moesif-api-analytics": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "moesif-api-analytics",
    name: "Moesif API Analytics",
    logoSquare: MoesifApiAnalyticsIcon,
    type: "app",
    key: "Moesif API Analytics",
  }),
  monetate: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "monetate",
    name: "Monetate",
    logoSquare: MonetateIcon,
    type: "app",
    key: "Monetate",
  }),
  moosend: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "moosend",
    name: "Moosend",
    logoSquare: MoosendIcon,
    type: "app",
    key: "Moosend",
  }),
  "movable-ink": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "movable-ink",
    name: "Movable Ink",
    logoSquare: MovableInkIcon,
    type: "app",
    key: "Movable Ink",
  }),
  msg91: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "msg91",
    name: "MSG91",
    logoSquare: Msg91Icon,
    type: "app",
    key: "MSG91",
  }),
  mutiny: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "mutiny",
    name: "Mutiny",
    logoSquare: MutinyIcon,
    type: "app",
    key: "Mutiny",
  }),
  nanigans: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "nanigans",
    name: "Nanigans",
    logoSquare: NanigansIcon,
    type: "advertising",
    key: "Nanigans",
  }),
  nat: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "nat",
    name: "Nat",
    logoSquare: NatIcon,
    type: "app",
    key: "Nat",
  }),
  natero: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "natero",
    name: "Natero",
    logoSquare: NateroIcon,
    type: "app",
    key: "Natero",
  }),
  navilytics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "navilytics",
    name: "Navilytics",
    logoSquare: NavilyticsIcon,
    type: "app",
    key: "Navilytics",
  }),
  "new-relic-insights": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "new-relic-insights",
    name: "New Relic Insights",
    logoSquare: NewRelicInsightsIcon,
    type: "app",
    key: "New Relic Insights",
  }),
  "nielsen-dcr": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "nielsen-dcr",
    name: "Nielsen DCR",
    logoSquare: NielsenDcrIcon,
    type: "app",
    key: "Nielsen DCR",
  }),
  noora: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "noora",
    name: "Noora",
    logoSquare: NooraIcon,
    type: "app",
    key: "Noora",
  }),
  nudgespot: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "nudgespot",
    name: "Nudgespot",
    logoSquare: NudgespotIcon,
    type: "app",
    key: "Nudgespot",
  }),
  "optimizely-x": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "optimizely-x",
    name: "Optimizely X",
    logoSquare: OptimizelyXIcon,
    type: "app",
    key: "Optimizely X",
  }),
  "oracle-eloqua": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "oracle-eloqua",
    name: "Oracle Eloqua",
    logoSquare: OracleEloquaIcon,
    type: "app",
    key: "Oracle Eloqua",
  }),
  "pardot-by-salesforce": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "pardot-by-salesforce",
    name: "Pardot by Salesforce",
    logoSquare: PardotbySalesforceIcon,
    type: "app",
    key: "Pardot by Salesforce",
  }),
  pendo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "pendo",
    name: "Pendo",
    logoSquare: PendoIcon,
    type: "app",
    key: "Pendo",
  }),
  "perfect-audience": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "perfect-audience",
    name: "Perfect Audience",
    logoSquare: PerfectAudienceIcon,
    type: "advertising",
    key: "Perfect Audience",
  }),
  "periscope-data": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "periscope-data",
    name: "Periscope Data",
    logoSquare: PeriscopeDataIcon,
    type: "app",
    key: "Periscope Data",
  }),
  perkville: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "perkville",
    name: "Perkville",
    logoSquare: PerkvilleIcon,
    type: "app",
    key: "Perkville",
  }),
  persistiq: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "persistiq",
    name: "PersistIQ",
    logoSquare: PersistIqIcon,
    type: "app",
    key: "PersistIQ",
  }),
  personyze: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "personyze",
    name: "Personyze",
    logoSquare: PersonyzeIcon,
    type: "app",
    key: "Personyze",
  }),
  pixelme: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "pixelme",
    name: "PixelMe",
    logoSquare: PixelMeIcon,
    type: "app",
    key: "PixelMe",
  }),
  planhat: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "planhat",
    name: "Planhat",
    logoSquare: PlanhatIcon,
    type: "app",
    key: "Planhat",
  }),
  pointillist: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "pointillist",
    name: "Pointillist",
    logoSquare: PointillistIcon,
    type: "app",
    key: "Pointillist",
  }),
  posthog: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "posthog",
    name: "PostHog",
    logoSquare: PostHogIcon,
    type: "app",
    key: "PostHog",
  }),
  productbird: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "productbird",
    name: "ProductBird",
    logoSquare: ProductBirdIcon,
    type: "app",
    key: "ProductBird",
  }),
  profitwell: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "profitwell",
    name: "ProfitWell",
    logoSquare: ProfitWellIcon,
    type: "app",
    key: "ProfitWell",
  }),
  "promoter-io": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "promoter-io",
    name: "Promoter.io",
    logoSquare: PromoterIoIcon,
    type: "app",
    key: "Promoter.io",
  }),
  "proof-experiences": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "proof-experiences",
    name: "Proof Experiences",
    logoSquare: ProofExperiencesIcon,
    type: "app",
    key: "Proof Experiences",
  }),
  prosperstack: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "prosperstack",
    name: "ProsperStack",
    logoSquare: ProsperStackIcon,
    type: "app",
    key: "ProsperStack",
  }),
  quantcast: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "quantcast",
    name: "Quantcast",
    logoSquare: QuantcastIcon,
    type: "advertising",
    key: "Quantcast",
  }),
  "quora-conversion-pixel": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "quora-conversion-pixel",
    name: "Quora Conversion Pixel",
    logoSquare: QuoraConversionPixelIcon,
    type: "advertising",
    key: "Quora Conversion Pixel",
  }),
  "radiumone-connect": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "radiumone-connect",
    name: "RadiumOne Connect",
    logoSquare: RadiumOneConnectIcon,
    type: "advertising",
    key: "RadiumOne Connect",
  }),
  ramen: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "ramen",
    name: "Ramen",
    logoSquare: RamenIcon,
    type: "app",
    key: "Ramen",
  }),
  "recombee-ai": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "recombee-ai",
    name: "Recombee AI",
    logoSquare: RecombeeAiIcon,
    type: "app",
    key: "Recombee AI",
  }),
  refersion: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "refersion",
    name: "Refersion",
    logoSquare: RefersionIcon,
    type: "app",
    key: "Refersion",
  }),
  refiner: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "refiner",
    name: "Refiner",
    logoSquare: RefinerIcon,
    type: "app",
    key: "Refiner",
  }),
  repeater: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "repeater",
    name: "Repeater",
    logoSquare: RepeaterIcon,
    type: "app",
    key: "Repeater",
  }),
  responsys: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "responsys",
    name: "Responsys",
    logoSquare: ResponsysIcon,
    type: "app",
    key: "Responsys",
  }),
  retently: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "retently",
    name: "Retently",
    logoSquare: RetentlyIcon,
    type: "app",
    key: "Retently",
  }),
  retina: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "retina",
    name: "Retina",
    logoSquare: RetinaIcon,
    type: "app",
    key: "Retina",
  }),
  richpanel: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "richpanel",
    name: "Richpanel",
    logoSquare: RichpanelIcon,
    type: "app",
    key: "Richpanel",
  }),
  rockerbox: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "rockerbox",
    name: "Rockerbox",
    logoSquare: RockerboxIcon,
    type: "app",
    key: "Rockerbox",
  }),
  "sailthru-v2": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "sailthru-v2",
    name: "Sailthru v2",
    logoSquare: Sailthruv2Icon,
    type: "app",
    key: "Sailthru v2",
  }),
  "salescamp-crm": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "salescamp-crm",
    name: "Salescamp CRM",
    logoSquare: SalescampCrmIcon,
    type: "app",
    key: "Salescamp CRM",
  }),
  salesforce: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "salesforce",
    name: "Salesforce",
    logoSquare: SalesforceIcon,
    type: "app",
    key: "Salesforce",
  }),
  salesmachine: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "salesmachine",
    name: "Salesmachine",
    logoSquare: SalesmachineIcon,
    type: "app",
    key: "Salesmachine",
  }),
  savio: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "savio",
    name: "Savio",
    logoSquare: SavioIcon,
    type: "app",
    key: "Savio",
  }),
  scopeai: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "scopeai",
    name: "ScopeAi",
    logoSquare: ScopeAiIcon,
    type: "app",
    key: "ScopeAi",
  }),
  screeb: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "screeb",
    name: "Screeb",
    logoSquare: ScreebIcon,
    type: "app",
    key: "Screeb",
  }),
  seg: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "seg",
    name: "Seg",
    logoSquare: SegIcon,
    type: "app",
    key: "Seg",
  }),
  segmetrics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "segmetrics",
    name: "SegMetrics",
    logoSquare: SegMetricsIcon,
    type: "app",
    key: "SegMetrics",
  }),
  "selligent-marketing-cloud": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "selligent-marketing-cloud",
    name: "Selligent Marketing Cloud",
    logoSquare: SelligentMarketingCloudIcon,
    type: "app",
    key: "Selligent Marketing Cloud",
  }),
  serenytics: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "serenytics",
    name: "Serenytics",
    logoSquare: SerenyticsIcon,
    type: "app",
    key: "Serenytics",
  }),
  shareasale: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "shareasale",
    name: "ShareASale",
    logoSquare: ShareASaleIcon,
    type: "advertising",
    key: "ShareASale",
  }),
  sherlock: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "sherlock",
    name: "Sherlock",
    logoSquare: SherlockIcon,
    type: "app",
    key: "Sherlock",
  }),
  simplereach: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "simplereach",
    name: "SimpleReach",
    logoSquare: SimpleReachIcon,
    type: "advertising",
    key: "SimpleReach",
  }),
  singular: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "singular",
    name: "Singular",
    logoSquare: SingularIcon,
    type: "app",
    key: "Singular",
  }),
  slack: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "slack",
    name: "Slack",
    logoSquare: SlackIcon,
    type: "app",
    key: "Slack",
  }),
  slicingdice: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "slicingdice",
    name: "SlicingDice",
    logoSquare: SlicingDiceIcon,
    type: "app",
    key: "SlicingDice",
  }),
  smartlook: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "smartlook",
    name: "Smartlook",
    logoSquare: SmartlookIcon,
    type: "app",
    key: "Smartlook",
  }),
  snapboard: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "snapboard",
    name: "Snapboard",
    logoSquare: SnapboardIcon,
    type: "app",
    key: "Snapboard",
  }),
  "snapchat-audiences": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "snapchat-audiences",
    name: "Snapchat Audiences",
    logoSquare: SnapchatAudiencesIcon,
    type: "cohorting",
    key: "Snapchat Audiences",
  }),
  spinnakr: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "spinnakr",
    name: "Spinnakr",
    logoSquare: SpinnakrIcon,
    type: "app",
    key: "Spinnakr",
  }),
  split: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "split",
    name: "Split",
    logoSquare: SplitIcon,
    type: "app",
    key: "Split",
  }),
  startdeliver: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "startdeliver",
    name: "Startdeliver",
    logoSquare: StartdeliverIcon,
    type: "app",
    key: "Startdeliver",
  }),
  statsig: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "statsig",
    name: "Statsig",
    logoSquare: StatsigIcon,
    type: "app",
    key: "Statsig",
  }),
  stitch: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "stitch",
    name: "Stitch",
    logoSquare: StitchIcon,
    type: "app",
    key: "Stitch",
  }),
  stories: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "stories",
    name: "Stories",
    logoSquare: StoriesIcon,
    type: "app",
    key: "Stories",
  }),
  stormly: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "stormly",
    name: "Stormly",
    logoSquare: StormlyIcon,
    type: "app",
    key: "Stormly",
  }),
  strikedeck: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "strikedeck",
    name: "Strikedeck",
    logoSquare: StrikedeckIcon,
    type: "app",
    key: "Strikedeck",
  }),
  survicate: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "survicate",
    name: "Survicate",
    logoSquare: SurvicateIcon,
    type: "app",
    key: "Survicate",
  }),
  swrve: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "swrve",
    name: "Swrve",
    logoSquare: SwrveIcon,
    type: "app",
    key: "Swrve",
  }),
  tableau: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tableau",
    name: "Tableau",
    logoSquare: TableauIcon,
    type: "app",
    key: "Tableau",
  }),
  talkable: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "talkable",
    name: "Talkable",
    logoSquare: TalkableIcon,
    type: "app",
    key: "Talkable",
  }),
  "talon-one": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "talon-one",
    name: "Talon.One",
    logoSquare: TalonOneIcon,
    type: "app",
    key: "Talon.One",
  }),
  tamber: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tamber",
    name: "Tamber",
    logoSquare: TamberIcon,
    type: "app",
    key: "Tamber",
  }),
  totango: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "totango",
    name: "Totango",
    logoSquare: TotangoIcon,
    type: "app",
    key: "Totango",
  }),
  "track-js": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "track-js",
    name: "Track JS",
    logoSquare: TrackJsIcon,
    type: "app",
    key: "Track JS",
  }),
  tractionboard: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tractionboard",
    name: "Tractionboard",
    logoSquare: TractionboardIcon,
    type: "app",
    key: "Tractionboard",
  }),
  trafficguard: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "trafficguard",
    name: "TrafficGuard",
    logoSquare: TrafficGuardIcon,
    type: "advertising",
    key: "TrafficGuard",
  }),
  "tray-io": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tray-io",
    name: "Tray.io",
    logoSquare: TrayIoIcon,
    type: "app",
    key: "Tray.io",
  }),
  "treasure-data": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "treasure-data",
    name: "Treasure Data",
    logoSquare: TreasureDataIcon,
    type: "app",
    key: "Treasure Data",
  }),
  tune: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tune",
    name: "TUNE",
    logoSquare: TuneIcon,
    type: "app",
    key: "TUNE",
  }),
  "tv-squared": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "tv-squared",
    name: "TV Squared",
    logoSquare: TvSquaredIcon,
    type: "advertising",
    key: "TV Squared",
  }),
  unwaffle: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "unwaffle",
    name: "Unwaffle",
    logoSquare: UnwaffleIcon,
    type: "app",
    key: "Unwaffle",
  }),
  upcall: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "upcall",
    name: "Upcall",
    logoSquare: UpcallIcon,
    type: "app",
    key: "Upcall",
  }),
  "user-com": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "user-com",
    name: "User.com",
    logoSquare: UserComIcon,
    type: "app",
    key: "User.com",
  }),
  useriq: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "useriq",
    name: "UserIQ",
    logoSquare: UserIqIcon,
    type: "app",
    key: "UserIQ",
  }),
  userleap: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "userleap",
    name: "UserLeap",
    logoSquare: UserLeapIcon,
    type: "app",
    key: "UserLeap",
  }),
  userlike: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "userlike",
    name: "Userlike",
    logoSquare: UserlikeIcon,
    type: "app",
    key: "Userlike",
  }),
  userlist: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "userlist",
    name: "Userlist",
    logoSquare: UserlistIcon,
    type: "app",
    key: "Userlist",
  }),
  uservoice: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "uservoice",
    name: "UserVoice",
    logoSquare: UserVoiceIcon,
    type: "app",
    key: "UserVoice",
  }),
  vespucci: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "vespucci",
    name: "Vespucci",
    logoSquare: VespucciIcon,
    type: "app",
    key: "Vespucci",
  }),
  vidora: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "vidora",
    name: "Vidora",
    logoSquare: VidoraIcon,
    type: "app",
    key: "Vidora",
  }),
  vitally: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "vitally",
    name: "Vitally",
    logoSquare: VitallyIcon,
    type: "app",
    key: "Vitally",
  }),
  voucherify: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "voucherify",
    name: "Voucherify",
    logoSquare: VoucherifyIcon,
    type: "app",
    key: "Voucherify",
  }),
  vwo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "vwo",
    name: "VWO",
    logoSquare: VwoIcon,
    type: "app",
    key: "VWO",
  }),
  walkme: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "walkme",
    name: "WalkMe",
    logoSquare: WalkMeIcon,
    type: "app",
    key: "WalkMe",
  }),
  "whale-watch": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "whale-watch",
    name: "Whale Watch",
    logoSquare: WhaleWatchIcon,
    type: "app",
    key: "Whale Watch",
  }),
  whalr: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "whalr",
    name: "Whalr",
    logoSquare: WhalrIcon,
    type: "app",
    key: "Whalr",
  }),
  wigzo: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "wigzo",
    name: "Wigzo",
    logoSquare: WigzoIcon,
    type: "app",
    key: "Wigzo",
  }),
  wishpond: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "wishpond",
    name: "Wishpond",
    logoSquare: WishpondIcon,
    type: "app",
    key: "Wishpond",
  }),
  xplenty: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "xplenty",
    name: "Xplenty",
    logoSquare: XplentyIcon,
    type: "app",
    key: "Xplenty",
  }),
  xtremepush: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "xtremepush",
    name: "Xtremepush",
    logoSquare: XtremepushIcon,
    type: "app",
    key: "Xtremepush",
  }),
  "yandex-metrica": new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "yandex-metrica",
    name: "Yandex Metrica",
    logoSquare: YandexMetricaIcon,
    type: "app",
    key: "Yandex Metrica",
  }),
  youbora: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "youbora",
    name: "Youbora",
    logoSquare: YouboraIcon,
    type: "app",
    key: "Youbora",
  }),
  zaius: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "zaius",
    name: "Zaius",
    logoSquare: ZaiusIcon,
    type: "advertising",
    key: "Zaius",
  }),
  zapier: new RequestableSaasDestination({
    destinationCategories: ["Data activation"],
    slug: "zapier",
    name: "Zapier",
    logoSquare: ZapierIcon,
    type: "app",
    key: "Zapier",
  }),
};

export type DestinationDefinition =
  | SaaSDestination
  | WarehouseDestination
  | RequestableSaasDestination;

export const allDestinationsData: Record<
  StaticDestinationSlug,
  DestinationDefinition
> = _.merge({}, saasDestinations, warehouseDestinations);

// @ts-ignore
export const destinationKeyToSlugMap: Record<
  DestinationName,
  StaticDestinationSlug
> = _.chain(allDestinationsData).keyBy("key").mapValues("slug").value();

export const slugForDestination = (dest: LoadedDestinationInfo) => {
  return (dest.name as DestinationKey) === "Function"
    ? (dest.function_id as string)
    : destinationKeyToSlugMap[dest.name];
};

// @ts-ignore
export const destinationSlugToNameMap: Record<
  DestinationName,
  StaticDestinationSlug
> = _.chain(allDestinationsData).keyBy("slug").mapValues("name").value();
